/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../pages/__root"
import { Route as StudioShowroomRouteImport } from "./../pages/studio-showroom"
import { Route as StudioSalesViewRouteImport } from "./../pages/studio-sales-view"
import { Route as StudioRouteImport } from "./../pages/studio"
import { Route as PlatformDiagnosticsRouteImport } from "./../pages/platform-diagnostics"
import { Route as IntelDriverBugRepro2024RouteImport } from "./../pages/intel-driver-bug-repro-2024"
import { Route as GraphicsTroubleshootingTestRouteImport } from "./../pages/graphics-troubleshooting-test"
import { Route as ErrorRouteImport } from "./../pages/error"
import { Route as R404RouteImport } from "./../pages/404"
import { Route as IndexRouteImport } from "./../pages/index"
import { Route as ShowroomIndexRouteImport } from "./../pages/showroom/index"
import { Route as DebugIndexRouteImport } from "./../pages/debug/index"
import { Route as AdminIndexRouteImport } from "./../pages/admin/index"
import { Route as ShowroomStudioRouteImport } from "./../pages/showroom/studio"
import { Route as ShowroomIntroRouteImport } from "./../pages/showroom/intro"
import { Route as InvitesInvite_idRouteImport } from "./../pages/invites/$invite_id"
import { Route as DemoShowroomRouteImport } from "./../pages/demo/showroom"
import { Route as DemoSheetsRouteImport } from "./../pages/demo/sheets"
import { Route as DemoPhotorealWalkthroughRouteImport } from "./../pages/demo/photoreal-walkthrough"
import { Route as DemoPhotorealSelections360WX34VCTU45P2RouteImport } from "./../pages/demo/photoreal-selections360-WX34VCTU45P2"
import { Route as DemoPhotorealSelectionsRouteImport } from "./../pages/demo/photoreal-selections"
import { Route as DemoPhotorealInterior360TS21DMPO80M1RouteImport } from "./../pages/demo/photoreal-interior360-TS21DMPO80M1"
import { Route as DemoIbs2023WalkthroughRouteImport } from "./../pages/demo/ibs-2023-walkthrough"
import { Route as DemoIbs2023StartRouteImport } from "./../pages/demo/ibs-2023-start"
import { Route as DemoIbs2023SelectionsRouteImport } from "./../pages/demo/ibs-2023-selections"
import { Route as DebugWebglServiceRouteImport } from "./../pages/debug/webgl-service"
import { Route as DebugWebglContextSharingTransformRouteImport } from "./../pages/debug/webgl-context-sharing-transform"
import { Route as DebugWebglContextSharingRouteImport } from "./../pages/debug/webgl-context-sharing"
import { Route as DebugWasmRouteImport } from "./../pages/debug/wasm"
import { Route as DebugWalkthroughCachingRouteImport } from "./../pages/debug/walkthrough-caching"
import { Route as DebugWalkthroughRouteImport } from "./../pages/debug/walkthrough"
import { Route as DebugViewerStateManagementRouteImport } from "./../pages/debug/viewer-state-management"
import { Route as DebugTonemappingTestRouteImport } from "./../pages/debug/tonemapping-test"
import { Route as DebugTextTestRouteImport } from "./../pages/debug/text-test"
import { Route as DebugSvgBbRouteImport } from "./../pages/debug/svg-bb"
import { Route as DebugStrokeTestRouteImport } from "./../pages/debug/stroke-test"
import { Route as DebugSsrrTestRouteImport } from "./../pages/debug/ssrr-test"
import { Route as DebugSourceGraphAnalyzerRouteImport } from "./../pages/debug/source-graph-analyzer"
import { Route as DebugShowroomIntroPerformanceRouteImport } from "./../pages/debug/showroom-intro-performance"
import { Route as DebugShowroomGltfImportPerformanceRouteImport } from "./../pages/debug/showroom-gltf-import-performance"
import { Route as DebugShowroomFloorplanRouteImport } from "./../pages/debug/showroom-floorplan"
import { Route as DebugServerErrorsRouteImport } from "./../pages/debug/server-errors"
import { Route as DebugSelectionsRouteImport } from "./../pages/debug/selections"
import { Route as DebugRepairHomeRouteImport } from "./../pages/debug/repair-home"
import { Route as DebugRenderRouteImport } from "./../pages/debug/render"
import { Route as DebugPropsRouteImport } from "./../pages/debug/props"
import { Route as DebugPropAwsBatchRouteImport } from "./../pages/debug/prop-aws-batch"
import { Route as DebugPropAwsAdminRouteImport } from "./../pages/debug/prop-aws-admin"
import { Route as DebugPlanarGraphRouteImport } from "./../pages/debug/planar-graph"
import { Route as DebugPlanRenderRouteImport } from "./../pages/debug/plan-render"
import { Route as DebugPdfDiffRouteImport } from "./../pages/debug/pdf-diff"
import { Route as DebugPanoramaViewerRouteImport } from "./../pages/debug/panorama-viewer"
import { Route as DebugPaletteThumbnailTestRouteImport } from "./../pages/debug/palette-thumbnail-test"
import { Route as DebugPaletteThumbnailCacheBustRouteImport } from "./../pages/debug/palette-thumbnail-cache-bust"
import { Route as DebugOptionCatalogRepairRouteImport } from "./../pages/debug/option-catalog-repair"
import { Route as DebugMaterialThumbnailsRouteImport } from "./../pages/debug/material-thumbnails"
import { Route as DebugMaterialIdRouteImport } from "./../pages/debug/material-id"
import { Route as DebugMaterialCacheManagerRouteImport } from "./../pages/debug/material-cache-manager"
import { Route as DebugMaterialAppearanceTestRouteImport } from "./../pages/debug/material-appearance-test"
import { Route as DebugImageServiceRouteImport } from "./../pages/debug/image-service"
import { Route as DebugIframeTestRouteImport } from "./../pages/debug/iframe-test"
import { Route as DebugHatchingTestRouteImport } from "./../pages/debug/hatching-test"
import { Route as DebugHatchMaterialGenerationRouteImport } from "./../pages/debug/hatch-material-generation"
import { Route as DebugFaceDiffViewerRouteImport } from "./../pages/debug/face-diff-viewer"
import { Route as DebugExteriorSceneRouteImport } from "./../pages/debug/exterior-scene"
import { Route as DebugExrTestRouteImport } from "./../pages/debug/exr-test"
import { Route as DebugExportRouteImport } from "./../pages/debug/export"
import { Route as DebugError403RouteImport } from "./../pages/debug/error-403"
import { Route as DebugDesignMaterialEditorRouteImport } from "./../pages/debug/design-material-editor"
import { Route as DebugDesignMaterialDocsRouteImport } from "./../pages/debug/design-material-docs"
import { Route as DebugDesignMaterialRouteImport } from "./../pages/debug/design-material"
import { Route as DebugCrashTestRouteImport } from "./../pages/debug/crash-test"
import { Route as DebugCompareRoofViewerRouteImport } from "./../pages/debug/compare-roof-viewer"
import { Route as DebugCalibrationTextureTestRouteImport } from "./../pages/debug/calibration-texture-test"
import { Route as DebugBuildingRendererRouteImport } from "./../pages/debug/building-renderer"
import { Route as DebugBuildingQueryRouteImport } from "./../pages/debug/building-query"
import { Route as DebugBuildingGltfLambdaRouteImport } from "./../pages/debug/building-gltf-lambda"
import { Route as DebugBuildingGltfRouteImport } from "./../pages/debug/building-gltf"
import { Route as DebugBuildingDebuggerRouteImport } from "./../pages/debug/building-debugger"
import { Route as DebugAnnotationRouteImport } from "./../pages/debug/annotation"
import { Route as AdminUsersRouteImport } from "./../pages/admin/users"
import { Route as AdminSettingsRouteImport } from "./../pages/admin/settings"
import { Route as AdminSelectionsRouteImport } from "./../pages/admin/selections"
import { Route as AdminPlanAnalysisRouteImport } from "./../pages/admin/plan-analysis"
import { Route as AdminHomesRouteImport } from "./../pages/admin/homes"
import { Route as AdminFeaturesRouteImport } from "./../pages/admin/features"
import { Route as AdminDebugRouteImport } from "./../pages/admin/debug"
import { Route as AdminBuildersRouteImport } from "./../pages/admin/builders"
import { Route as AccountUpdatePasswordRouteImport } from "./../pages/account/update-password"
import { Route as AccountResetPasswordRouteImport } from "./../pages/account/reset-password"
import { Route as AccountLoginRouteImport } from "./../pages/account/login"
import { Route as AccountDashboardRouteImport } from "./../pages/account/dashboard"
import { Route as AccountCallbackRouteImport } from "./../pages/account/callback"
import { Route as DemoConnectedIndexRouteImport } from "./../pages/demo/connected/index"
import { Route as DebugWallFramingIndexRouteImport } from "./../pages/debug/wall-framing/index"
import { Route as DebugOptionMigrationIndexRouteImport } from "./../pages/debug/option-migration/index"
import { Route as DebugGeomIndexRouteImport } from "./../pages/debug/geom/index"
import { Route as DebugFloorFramingIndexRouteImport } from "./../pages/debug/floor-framing/index"
import { Route as DebugBuilderWebsiteIndexRouteImport } from "./../pages/debug/builder-website/index"
import { Route as BuildersBuilder_idIndexRouteImport } from "./../pages/builders/$builder_id/index"
import { Route as AdminDataMigrationIndexRouteImport } from "./../pages/admin/data-migration/index"
import { Route as AdminComponentLibraryIndexRouteImport } from "./../pages/admin/component-library/index"
import { Route as ShowroomEditIntroRouteImport } from "./../pages/showroom/edit/intro"
import { Route as DemoConnectedTabsRouteImport } from "./../pages/demo/connected/tabs"
import { Route as DemoConnectedSinglescreenRouteImport } from "./../pages/demo/connected/singlescreen"
import { Route as DemoConnectedShowroomRouteImport } from "./../pages/demo/connected/showroom"
import { Route as DemoConnectedBigscreenRouteImport } from "./../pages/demo/connected/bigscreen"
import { Route as DebugSchemaBuildingApiRouteImport } from "./../pages/debug/schema/building-api"
import { Route as DebugSchemaBapiKamsRouteImport } from "./../pages/debug/schema/bapi-kams"
import { Route as DebugPolyclipTrimFacesTestRouteImport } from "./../pages/debug/polyclip/trim-faces-test"
import { Route as DebugPolyclipSnapRoundTestRouteImport } from "./../pages/debug/polyclip/snap-round-test"
import { Route as DebugPolyclipSetOpsTestRouteImport } from "./../pages/debug/polyclip/set-ops-test"
import { Route as DebugPolyclipSetOpsFuzzRouteImport } from "./../pages/debug/polyclip/set-ops-fuzz"
import { Route as DebugPolyclipSetOpsBenchRouteImport } from "./../pages/debug/polyclip/set-ops-bench"
import { Route as DebugPolyclipPlaneTrimTestRouteImport } from "./../pages/debug/polyclip/plane-trim-test"
import { Route as DebugPolyclipOffsetClosedTestRouteImport } from "./../pages/debug/polyclip/offset-closed-test"
import { Route as DebugPolyclipBrepTrimTestRouteImport } from "./../pages/debug/polyclip/brep-trim-test"
import { Route as DebugPolyclipBrepSetOpsTestRouteImport } from "./../pages/debug/polyclip/brep-set-ops-test"
import { Route as DebugOptionMigrationMigrateOptionsRouteImport } from "./../pages/debug/option-migration/migrate-options"
import { Route as DebugGfxTestThreeviewerInitRouteImport } from "./../pages/debug/gfx-test/threeviewer-init"
import { Route as DebugGfxTestMaterialRenderRouteImport } from "./../pages/debug/gfx-test/material-render"
import { Route as DebugGfxStressMaterialStressIncrementalRouteImport } from "./../pages/debug/gfx-stress/material-stress-incremental"
import { Route as DebugGfxStressMaterialStressRouteImport } from "./../pages/debug/gfx-stress/material-stress"
import { Route as DebugGfxStressGeometryStressIncrementalRouteImport } from "./../pages/debug/gfx-stress/geometry-stress-incremental"
import { Route as DebugGeomStraightSkeletonOffsetSingleRouteImport } from "./../pages/debug/geom/straight-skeleton-offset-single"
import { Route as DebugGeomStraightSkeletonOffsetRouteImport } from "./../pages/debug/geom/straight-skeleton-offset"
import { Route as DebugFramingTruss2DRouteImport } from "./../pages/debug/framing/truss2D"
import { Route as DebugBuilderWebsiteShowroomIntroRouteImport } from "./../pages/debug/builder-website/showroom-intro"
import { Route as DebugBuilderWebsiteSalesMapRouteImport } from "./../pages/debug/builder-website/sales-map"
import { Route as BuildersBuilder_idPlansRouteImport } from "./../pages/builders/$builder_id/plans"
import { Route as BuildersBuilder_idGuidedFlowRouteImport } from "./../pages/builders/$builder_id/guided-flow"
import { Route as BuildersBuilder_idFilesRouteImport } from "./../pages/builders/$builder_id/files"
import { Route as BuildersBuilder_idConfigureRouteImport } from "./../pages/builders/$builder_id/configure"
import { Route as BuildersBuilder_idOptionsRouteRouteImport } from "./../pages/builders/$builder_id/options/route"
import { Route as BuildersBuilder_idEstimateRouteRouteImport } from "./../pages/builders/$builder_id/estimate/route"
import { Route as ShowroomPlanHome_plan_idIndexRouteImport } from "./../pages/showroom/plan/$home_plan_id/index"
import { Route as DebugGeomMiterSkeletonIndexRouteImport } from "./../pages/debug/geom/miter-skeleton/index"
import { Route as BuildersBuilder_idUsersIndexRouteImport } from "./../pages/builders/$builder_id/users/index"
import { Route as BuildersBuilder_idTasksIndexRouteImport } from "./../pages/builders/$builder_id/tasks/index"
import { Route as BuildersBuilder_idOptionsIndexRouteImport } from "./../pages/builders/$builder_id/options/index"
import { Route as BuildersBuilder_idMasterPlansIndexRouteImport } from "./../pages/builders/$builder_id/master-plans/index"
import { Route as BuildersBuilder_idMarketingIndexRouteImport } from "./../pages/builders/$builder_id/marketing/index"
import { Route as BuildersBuilder_idLocationsIndexRouteImport } from "./../pages/builders/$builder_id/locations/index"
import { Route as BuildersBuilder_idIntegrationsIndexRouteImport } from "./../pages/builders/$builder_id/integrations/index"
import { Route as BuildersBuilder_idEstimateIndexRouteImport } from "./../pages/builders/$builder_id/estimate/index"
import { Route as BuildersBuilder_idDevelopersIndexRouteImport } from "./../pages/builders/$builder_id/developers/index"
import { Route as BuildersBuilder_idCommunitiesIndexRouteImport } from "./../pages/builders/$builder_id/communities/index"
import { Route as BuildersBuilder_idAutoRendersIndexRouteImport } from "./../pages/builders/$builder_id/auto-renders/index"
import { Route as BuildersBuilder_idAccountIndexRouteImport } from "./../pages/builders/$builder_id/account/index"
import { Route as ShowroomPlanHome_plan_idOverviewRouteImport } from "./../pages/showroom/plan/$home_plan_id/overview"
import { Route as ShowroomPlanHome_plan_idOpsRouteImport } from "./../pages/showroom/plan/$home_plan_id/ops"
import { Route as DebugGeomMiterSkeletonSkeletonRouteImport } from "./../pages/debug/geom/miter-skeleton/skeleton"
import { Route as BuildersBuilder_idProcureSplatRouteImport } from "./../pages/builders/$builder_id/procure/$"
import { Route as BuildersBuilder_idLocationsNewRouteImport } from "./../pages/builders/$builder_id/locations/new"
import { Route as BuildersBuilder_idTasksTask_idIndexRouteImport } from "./../pages/builders/$builder_id/tasks/$task_id/index"
import { Route as BuildersBuilder_idMasterPlansMaster_plan_idIndexRouteImport } from "./../pages/builders/$builder_id/master-plans/$master_plan_id/index"
import { Route as BuildersBuilder_idHomePlansHome_plan_idIndexRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/index"
import { Route as BuildersBuilder_idEstimateIntegrationsIndexRouteImport } from "./../pages/builders/$builder_id/estimate/integrations/index"
import { Route as BuildersBuilder_idAutoRendersItem_idIndexRouteImport } from "./../pages/builders/$builder_id/auto-renders/$item_id/index"
import { Route as BuildersBuilder_idOptionsEditSetsRouteImport } from "./../pages/builders/$builder_id/options/edit/sets"
import { Route as BuildersBuilder_idOptionsEditSetRouteImport } from "./../pages/builders/$builder_id/options/edit/set"
import { Route as BuildersBuilder_idOptionsEditOptionsRouteImport } from "./../pages/builders/$builder_id/options/edit/options"
import { Route as BuildersBuilder_idMasterPlansMaster_plan_idShowroomRouteImport } from "./../pages/builders/$builder_id/master-plans/$master_plan_id/showroom"
import { Route as BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRouteImport } from "./../pages/builders/$builder_id/master-plans/$master_plan_id/sales-view"
import { Route as BuildersBuilder_idLocationsLocation_idHomePlansRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/home-plans"
import { Route as BuildersBuilder_idLocationsLocation_idEditRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/edit"
import { Route as BuildersBuilder_idHomePlansHome_plan_idSalesViewRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/sales-view"
import { Route as BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
import { Route as BuildersBuilder_idHomePlansHome_plan_idOverviewRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/overview"
import { Route as BuildersBuilder_idEstimateIntegrationsResourcesRouteImport } from "./../pages/builders/$builder_id/estimate/integrations/resources"
import { Route as BuildersBuilder_idEstimateIntegrationsCustomfieldsRouteImport } from "./../pages/builders/$builder_id/estimate/integrations/customfields"
import { Route as BuildersBuilder_idEstimateIntegrationsCostcodesRouteImport } from "./../pages/builders/$builder_id/estimate/integrations/costcodes"
import { Route as BuildersBuilder_idCommunitiesCommunity_idPlansRouteImport } from "./../pages/builders/$builder_id/communities/$community_id/plans"
import { Route as BuildersBuilder_idCommunitiesCommunity_idSplatRouteImport } from "./../pages/builders/$builder_id/communities/$community_id/$"
import { Route as DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRouteImport } from "./../pages/demo/builders/$builder_name/walkthroughs/$walkthrough_id/index"
import { Route as DemoBuildersBuilder_nameSelectionsScene_idIndexRouteImport } from "./../pages/demo/builders/$builder_name/selections/$scene_id/index"
import { Route as BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRouteImport } from "./../pages/builders/$builder_id/marketing/master-plans/$master_plan_id/index"
import { Route as BuildersBuilder_idLocationsLocation_idWorkbooksIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/workbooks/index"
import { Route as BuildersBuilder_idLocationsLocation_idTasksIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/tasks/index"
import { Route as BuildersBuilder_idLocationsLocation_idSubLocationsIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/sub-locations/index"
import { Route as BuildersBuilder_idLocationsLocation_idStudioDocsIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/studio-docs/index"
import { Route as BuildersBuilder_idLocationsLocation_idSalesMapIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/sales-map/index"
import { Route as BuildersBuilder_idLocationsLocation_idOptionsIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/options/index"
import { Route as BuildersBuilder_idLocationsLocation_idMapIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/map/index"
import { Route as BuildersBuilder_idLocationsLocation_idLotsIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/lots/index"
import { Route as BuildersBuilder_idLocationsLocation_idLocationPlansIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/location-plans/index"
import { Route as BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/showroom/index"
import { Route as BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRouteImport } from "./../pages/builders/$builder_id/home-plans/$home_plan_id/ops-view/index"
import { Route as BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRouteImport } from "./../pages/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
import { Route as BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/lots/$lot_id/index"
import { Route as BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/index"
import { Route as BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRouteImport } from "./../pages/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
import { Route as BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
import { Route as BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRouteImport } from "./../pages/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/index"
import { Route as BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRouteImport } from "./../pages/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
import { Route as BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/index"
import { Route as BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRouteImport } from "./../pages/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
import { Route as BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRouteImport } from "./../pages/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"

const StudioShowroomRoute = StudioShowroomRouteImport.update({
  id: "/studio-showroom",
  path: "/studio-showroom",
  getParentRoute: () => rootRouteImport,
} as any)
const StudioSalesViewRoute = StudioSalesViewRouteImport.update({
  id: "/studio-sales-view",
  path: "/studio-sales-view",
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: "/studio",
  path: "/studio",
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformDiagnosticsRoute = PlatformDiagnosticsRouteImport.update({
  id: "/platform-diagnostics",
  path: "/platform-diagnostics",
  getParentRoute: () => rootRouteImport,
} as any)
const IntelDriverBugRepro2024Route = IntelDriverBugRepro2024RouteImport.update({
  id: "/intel-driver-bug-repro-2024",
  path: "/intel-driver-bug-repro-2024",
  getParentRoute: () => rootRouteImport,
} as any)
const GraphicsTroubleshootingTestRoute =
  GraphicsTroubleshootingTestRouteImport.update({
    id: "/graphics-troubleshooting-test",
    path: "/graphics-troubleshooting-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const ErrorRoute = ErrorRouteImport.update({
  id: "/error",
  path: "/error",
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: "/404",
  path: "/404",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ShowroomIndexRoute = ShowroomIndexRouteImport.update({
  id: "/showroom/",
  path: "/showroom/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugIndexRoute = DebugIndexRouteImport.update({
  id: "/debug/",
  path: "/debug/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => rootRouteImport,
} as any)
const ShowroomStudioRoute = ShowroomStudioRouteImport.update({
  id: "/showroom/studio",
  path: "/showroom/studio",
  getParentRoute: () => rootRouteImport,
} as any)
const ShowroomIntroRoute = ShowroomIntroRouteImport.update({
  id: "/showroom/intro",
  path: "/showroom/intro",
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesInvite_idRoute = InvitesInvite_idRouteImport.update({
  id: "/invites/$invite_id",
  path: "/invites/$invite_id",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoShowroomRoute = DemoShowroomRouteImport.update({
  id: "/demo/showroom",
  path: "/demo/showroom",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoSheetsRoute = DemoSheetsRouteImport.update({
  id: "/demo/sheets",
  path: "/demo/sheets",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoPhotorealWalkthroughRoute =
  DemoPhotorealWalkthroughRouteImport.update({
    id: "/demo/photoreal-walkthrough",
    path: "/demo/photoreal-walkthrough",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoPhotorealSelections360WX34VCTU45P2Route =
  DemoPhotorealSelections360WX34VCTU45P2RouteImport.update({
    id: "/demo/photoreal-selections360-WX34VCTU45P2",
    path: "/demo/photoreal-selections360-WX34VCTU45P2",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoPhotorealSelectionsRoute = DemoPhotorealSelectionsRouteImport.update({
  id: "/demo/photoreal-selections",
  path: "/demo/photoreal-selections",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoPhotorealInterior360TS21DMPO80M1Route =
  DemoPhotorealInterior360TS21DMPO80M1RouteImport.update({
    id: "/demo/photoreal-interior360-TS21DMPO80M1",
    path: "/demo/photoreal-interior360-TS21DMPO80M1",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoIbs2023WalkthroughRoute = DemoIbs2023WalkthroughRouteImport.update({
  id: "/demo/ibs-2023-walkthrough",
  path: "/demo/ibs-2023-walkthrough",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIbs2023StartRoute = DemoIbs2023StartRouteImport.update({
  id: "/demo/ibs-2023-start",
  path: "/demo/ibs-2023-start",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIbs2023SelectionsRoute = DemoIbs2023SelectionsRouteImport.update({
  id: "/demo/ibs-2023-selections",
  path: "/demo/ibs-2023-selections",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugWebglServiceRoute = DebugWebglServiceRouteImport.update({
  id: "/debug/webgl-service",
  path: "/debug/webgl-service",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugWebglContextSharingTransformRoute =
  DebugWebglContextSharingTransformRouteImport.update({
    id: "/debug/webgl-context-sharing-transform",
    path: "/debug/webgl-context-sharing-transform",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugWebglContextSharingRoute =
  DebugWebglContextSharingRouteImport.update({
    id: "/debug/webgl-context-sharing",
    path: "/debug/webgl-context-sharing",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugWasmRoute = DebugWasmRouteImport.update({
  id: "/debug/wasm",
  path: "/debug/wasm",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugWalkthroughCachingRoute = DebugWalkthroughCachingRouteImport.update({
  id: "/debug/walkthrough-caching",
  path: "/debug/walkthrough-caching",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugWalkthroughRoute = DebugWalkthroughRouteImport.update({
  id: "/debug/walkthrough",
  path: "/debug/walkthrough",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugViewerStateManagementRoute =
  DebugViewerStateManagementRouteImport.update({
    id: "/debug/viewer-state-management",
    path: "/debug/viewer-state-management",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugTonemappingTestRoute = DebugTonemappingTestRouteImport.update({
  id: "/debug/tonemapping-test",
  path: "/debug/tonemapping-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugTextTestRoute = DebugTextTestRouteImport.update({
  id: "/debug/text-test",
  path: "/debug/text-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSvgBbRoute = DebugSvgBbRouteImport.update({
  id: "/debug/svg-bb",
  path: "/debug/svg-bb",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugStrokeTestRoute = DebugStrokeTestRouteImport.update({
  id: "/debug/stroke-test",
  path: "/debug/stroke-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSsrrTestRoute = DebugSsrrTestRouteImport.update({
  id: "/debug/ssrr-test",
  path: "/debug/ssrr-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSourceGraphAnalyzerRoute =
  DebugSourceGraphAnalyzerRouteImport.update({
    id: "/debug/source-graph-analyzer",
    path: "/debug/source-graph-analyzer",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugShowroomIntroPerformanceRoute =
  DebugShowroomIntroPerformanceRouteImport.update({
    id: "/debug/showroom-intro-performance",
    path: "/debug/showroom-intro-performance",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugShowroomGltfImportPerformanceRoute =
  DebugShowroomGltfImportPerformanceRouteImport.update({
    id: "/debug/showroom-gltf-import-performance",
    path: "/debug/showroom-gltf-import-performance",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugShowroomFloorplanRoute = DebugShowroomFloorplanRouteImport.update({
  id: "/debug/showroom-floorplan",
  path: "/debug/showroom-floorplan",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugServerErrorsRoute = DebugServerErrorsRouteImport.update({
  id: "/debug/server-errors",
  path: "/debug/server-errors",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSelectionsRoute = DebugSelectionsRouteImport.update({
  id: "/debug/selections",
  path: "/debug/selections",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRepairHomeRoute = DebugRepairHomeRouteImport.update({
  id: "/debug/repair-home",
  path: "/debug/repair-home",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRenderRoute = DebugRenderRouteImport.update({
  id: "/debug/render",
  path: "/debug/render",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPropsRoute = DebugPropsRouteImport.update({
  id: "/debug/props",
  path: "/debug/props",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPropAwsBatchRoute = DebugPropAwsBatchRouteImport.update({
  id: "/debug/prop-aws-batch",
  path: "/debug/prop-aws-batch",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPropAwsAdminRoute = DebugPropAwsAdminRouteImport.update({
  id: "/debug/prop-aws-admin",
  path: "/debug/prop-aws-admin",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPlanarGraphRoute = DebugPlanarGraphRouteImport.update({
  id: "/debug/planar-graph",
  path: "/debug/planar-graph",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPlanRenderRoute = DebugPlanRenderRouteImport.update({
  id: "/debug/plan-render",
  path: "/debug/plan-render",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPdfDiffRoute = DebugPdfDiffRouteImport.update({
  id: "/debug/pdf-diff",
  path: "/debug/pdf-diff",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPanoramaViewerRoute = DebugPanoramaViewerRouteImport.update({
  id: "/debug/panorama-viewer",
  path: "/debug/panorama-viewer",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPaletteThumbnailTestRoute =
  DebugPaletteThumbnailTestRouteImport.update({
    id: "/debug/palette-thumbnail-test",
    path: "/debug/palette-thumbnail-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPaletteThumbnailCacheBustRoute =
  DebugPaletteThumbnailCacheBustRouteImport.update({
    id: "/debug/palette-thumbnail-cache-bust",
    path: "/debug/palette-thumbnail-cache-bust",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugOptionCatalogRepairRoute =
  DebugOptionCatalogRepairRouteImport.update({
    id: "/debug/option-catalog-repair",
    path: "/debug/option-catalog-repair",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugMaterialThumbnailsRoute = DebugMaterialThumbnailsRouteImport.update({
  id: "/debug/material-thumbnails",
  path: "/debug/material-thumbnails",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugMaterialIdRoute = DebugMaterialIdRouteImport.update({
  id: "/debug/material-id",
  path: "/debug/material-id",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugMaterialCacheManagerRoute =
  DebugMaterialCacheManagerRouteImport.update({
    id: "/debug/material-cache-manager",
    path: "/debug/material-cache-manager",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugMaterialAppearanceTestRoute =
  DebugMaterialAppearanceTestRouteImport.update({
    id: "/debug/material-appearance-test",
    path: "/debug/material-appearance-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugImageServiceRoute = DebugImageServiceRouteImport.update({
  id: "/debug/image-service",
  path: "/debug/image-service",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugIframeTestRoute = DebugIframeTestRouteImport.update({
  id: "/debug/iframe-test",
  path: "/debug/iframe-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugHatchingTestRoute = DebugHatchingTestRouteImport.update({
  id: "/debug/hatching-test",
  path: "/debug/hatching-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugHatchMaterialGenerationRoute =
  DebugHatchMaterialGenerationRouteImport.update({
    id: "/debug/hatch-material-generation",
    path: "/debug/hatch-material-generation",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugFaceDiffViewerRoute = DebugFaceDiffViewerRouteImport.update({
  id: "/debug/face-diff-viewer",
  path: "/debug/face-diff-viewer",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugExteriorSceneRoute = DebugExteriorSceneRouteImport.update({
  id: "/debug/exterior-scene",
  path: "/debug/exterior-scene",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugExrTestRoute = DebugExrTestRouteImport.update({
  id: "/debug/exr-test",
  path: "/debug/exr-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugExportRoute = DebugExportRouteImport.update({
  id: "/debug/export",
  path: "/debug/export",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugError403Route = DebugError403RouteImport.update({
  id: "/debug/error-403",
  path: "/debug/error-403",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugDesignMaterialEditorRoute =
  DebugDesignMaterialEditorRouteImport.update({
    id: "/debug/design-material-editor",
    path: "/debug/design-material-editor",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugDesignMaterialDocsRoute = DebugDesignMaterialDocsRouteImport.update({
  id: "/debug/design-material-docs",
  path: "/debug/design-material-docs",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugDesignMaterialRoute = DebugDesignMaterialRouteImport.update({
  id: "/debug/design-material",
  path: "/debug/design-material",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugCrashTestRoute = DebugCrashTestRouteImport.update({
  id: "/debug/crash-test",
  path: "/debug/crash-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugCompareRoofViewerRoute = DebugCompareRoofViewerRouteImport.update({
  id: "/debug/compare-roof-viewer",
  path: "/debug/compare-roof-viewer",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugCalibrationTextureTestRoute =
  DebugCalibrationTextureTestRouteImport.update({
    id: "/debug/calibration-texture-test",
    path: "/debug/calibration-texture-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugBuildingRendererRoute = DebugBuildingRendererRouteImport.update({
  id: "/debug/building-renderer",
  path: "/debug/building-renderer",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuildingQueryRoute = DebugBuildingQueryRouteImport.update({
  id: "/debug/building-query",
  path: "/debug/building-query",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuildingGltfLambdaRoute = DebugBuildingGltfLambdaRouteImport.update({
  id: "/debug/building-gltf-lambda",
  path: "/debug/building-gltf-lambda",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuildingGltfRoute = DebugBuildingGltfRouteImport.update({
  id: "/debug/building-gltf",
  path: "/debug/building-gltf",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuildingDebuggerRoute = DebugBuildingDebuggerRouteImport.update({
  id: "/debug/building-debugger",
  path: "/debug/building-debugger",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugAnnotationRoute = DebugAnnotationRouteImport.update({
  id: "/debug/annotation",
  path: "/debug/annotation",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: "/admin/settings",
  path: "/admin/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSelectionsRoute = AdminSelectionsRouteImport.update({
  id: "/admin/selections",
  path: "/admin/selections",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlanAnalysisRoute = AdminPlanAnalysisRouteImport.update({
  id: "/admin/plan-analysis",
  path: "/admin/plan-analysis",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHomesRoute = AdminHomesRouteImport.update({
  id: "/admin/homes",
  path: "/admin/homes",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeaturesRoute = AdminFeaturesRouteImport.update({
  id: "/admin/features",
  path: "/admin/features",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDebugRoute = AdminDebugRouteImport.update({
  id: "/admin/debug",
  path: "/admin/debug",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBuildersRoute = AdminBuildersRouteImport.update({
  id: "/admin/builders",
  path: "/admin/builders",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountUpdatePasswordRoute = AccountUpdatePasswordRouteImport.update({
  id: "/account/update-password",
  path: "/account/update-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountResetPasswordRoute = AccountResetPasswordRouteImport.update({
  id: "/account/reset-password",
  path: "/account/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLoginRoute = AccountLoginRouteImport.update({
  id: "/account/login",
  path: "/account/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDashboardRoute = AccountDashboardRouteImport.update({
  id: "/account/dashboard",
  path: "/account/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountCallbackRoute = AccountCallbackRouteImport.update({
  id: "/account/callback",
  path: "/account/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoConnectedIndexRoute = DemoConnectedIndexRouteImport.update({
  id: "/demo/connected/",
  path: "/demo/connected/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugWallFramingIndexRoute = DebugWallFramingIndexRouteImport.update({
  id: "/debug/wall-framing/",
  path: "/debug/wall-framing/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugOptionMigrationIndexRoute =
  DebugOptionMigrationIndexRouteImport.update({
    id: "/debug/option-migration/",
    path: "/debug/option-migration/",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGeomIndexRoute = DebugGeomIndexRouteImport.update({
  id: "/debug/geom/",
  path: "/debug/geom/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugFloorFramingIndexRoute = DebugFloorFramingIndexRouteImport.update({
  id: "/debug/floor-framing/",
  path: "/debug/floor-framing/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuilderWebsiteIndexRoute =
  DebugBuilderWebsiteIndexRouteImport.update({
    id: "/debug/builder-website/",
    path: "/debug/builder-website/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idIndexRoute = BuildersBuilder_idIndexRouteImport.update({
  id: "/builders/$builder_id/",
  path: "/builders/$builder_id/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDataMigrationIndexRoute = AdminDataMigrationIndexRouteImport.update({
  id: "/admin/data-migration/",
  path: "/admin/data-migration/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminComponentLibraryIndexRoute =
  AdminComponentLibraryIndexRouteImport.update({
    id: "/admin/component-library/",
    path: "/admin/component-library/",
    getParentRoute: () => rootRouteImport,
  } as any)
const ShowroomEditIntroRoute = ShowroomEditIntroRouteImport.update({
  id: "/showroom/edit/intro",
  path: "/showroom/edit/intro",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoConnectedTabsRoute = DemoConnectedTabsRouteImport.update({
  id: "/demo/connected/tabs",
  path: "/demo/connected/tabs",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoConnectedSinglescreenRoute =
  DemoConnectedSinglescreenRouteImport.update({
    id: "/demo/connected/singlescreen",
    path: "/demo/connected/singlescreen",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoConnectedShowroomRoute = DemoConnectedShowroomRouteImport.update({
  id: "/demo/connected/showroom",
  path: "/demo/connected/showroom",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoConnectedBigscreenRoute = DemoConnectedBigscreenRouteImport.update({
  id: "/demo/connected/bigscreen",
  path: "/demo/connected/bigscreen",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSchemaBuildingApiRoute = DebugSchemaBuildingApiRouteImport.update({
  id: "/debug/schema/building-api",
  path: "/debug/schema/building-api",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSchemaBapiKamsRoute = DebugSchemaBapiKamsRouteImport.update({
  id: "/debug/schema/bapi-kams",
  path: "/debug/schema/bapi-kams",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPolyclipTrimFacesTestRoute =
  DebugPolyclipTrimFacesTestRouteImport.update({
    id: "/debug/polyclip/trim-faces-test",
    path: "/debug/polyclip/trim-faces-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipSnapRoundTestRoute =
  DebugPolyclipSnapRoundTestRouteImport.update({
    id: "/debug/polyclip/snap-round-test",
    path: "/debug/polyclip/snap-round-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipSetOpsTestRoute = DebugPolyclipSetOpsTestRouteImport.update({
  id: "/debug/polyclip/set-ops-test",
  path: "/debug/polyclip/set-ops-test",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPolyclipSetOpsFuzzRoute = DebugPolyclipSetOpsFuzzRouteImport.update({
  id: "/debug/polyclip/set-ops-fuzz",
  path: "/debug/polyclip/set-ops-fuzz",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugPolyclipSetOpsBenchRoute =
  DebugPolyclipSetOpsBenchRouteImport.update({
    id: "/debug/polyclip/set-ops-bench",
    path: "/debug/polyclip/set-ops-bench",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipPlaneTrimTestRoute =
  DebugPolyclipPlaneTrimTestRouteImport.update({
    id: "/debug/polyclip/plane-trim-test",
    path: "/debug/polyclip/plane-trim-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipOffsetClosedTestRoute =
  DebugPolyclipOffsetClosedTestRouteImport.update({
    id: "/debug/polyclip/offset-closed-test",
    path: "/debug/polyclip/offset-closed-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipBrepTrimTestRoute =
  DebugPolyclipBrepTrimTestRouteImport.update({
    id: "/debug/polyclip/brep-trim-test",
    path: "/debug/polyclip/brep-trim-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugPolyclipBrepSetOpsTestRoute =
  DebugPolyclipBrepSetOpsTestRouteImport.update({
    id: "/debug/polyclip/brep-set-ops-test",
    path: "/debug/polyclip/brep-set-ops-test",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugOptionMigrationMigrateOptionsRoute =
  DebugOptionMigrationMigrateOptionsRouteImport.update({
    id: "/debug/option-migration/migrate-options",
    path: "/debug/option-migration/migrate-options",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGfxTestThreeviewerInitRoute =
  DebugGfxTestThreeviewerInitRouteImport.update({
    id: "/debug/gfx-test/threeviewer-init",
    path: "/debug/gfx-test/threeviewer-init",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGfxTestMaterialRenderRoute =
  DebugGfxTestMaterialRenderRouteImport.update({
    id: "/debug/gfx-test/material-render",
    path: "/debug/gfx-test/material-render",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGfxStressMaterialStressIncrementalRoute =
  DebugGfxStressMaterialStressIncrementalRouteImport.update({
    id: "/debug/gfx-stress/material-stress-incremental",
    path: "/debug/gfx-stress/material-stress-incremental",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGfxStressMaterialStressRoute =
  DebugGfxStressMaterialStressRouteImport.update({
    id: "/debug/gfx-stress/material-stress",
    path: "/debug/gfx-stress/material-stress",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGfxStressGeometryStressIncrementalRoute =
  DebugGfxStressGeometryStressIncrementalRouteImport.update({
    id: "/debug/gfx-stress/geometry-stress-incremental",
    path: "/debug/gfx-stress/geometry-stress-incremental",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGeomStraightSkeletonOffsetSingleRoute =
  DebugGeomStraightSkeletonOffsetSingleRouteImport.update({
    id: "/debug/geom/straight-skeleton-offset-single",
    path: "/debug/geom/straight-skeleton-offset-single",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGeomStraightSkeletonOffsetRoute =
  DebugGeomStraightSkeletonOffsetRouteImport.update({
    id: "/debug/geom/straight-skeleton-offset",
    path: "/debug/geom/straight-skeleton-offset",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugFramingTruss2DRoute = DebugFramingTruss2DRouteImport.update({
  id: "/debug/framing/truss2D",
  path: "/debug/framing/truss2D",
  getParentRoute: () => rootRouteImport,
} as any)
const DebugBuilderWebsiteShowroomIntroRoute =
  DebugBuilderWebsiteShowroomIntroRouteImport.update({
    id: "/debug/builder-website/showroom-intro",
    path: "/debug/builder-website/showroom-intro",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugBuilderWebsiteSalesMapRoute =
  DebugBuilderWebsiteSalesMapRouteImport.update({
    id: "/debug/builder-website/sales-map",
    path: "/debug/builder-website/sales-map",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idPlansRoute = BuildersBuilder_idPlansRouteImport.update({
  id: "/builders/$builder_id/plans",
  path: "/builders/$builder_id/plans",
  getParentRoute: () => rootRouteImport,
} as any)
const BuildersBuilder_idGuidedFlowRoute =
  BuildersBuilder_idGuidedFlowRouteImport.update({
    id: "/builders/$builder_id/guided-flow",
    path: "/builders/$builder_id/guided-flow",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idFilesRoute = BuildersBuilder_idFilesRouteImport.update({
  id: "/builders/$builder_id/files",
  path: "/builders/$builder_id/files",
  getParentRoute: () => rootRouteImport,
} as any)
const BuildersBuilder_idConfigureRoute =
  BuildersBuilder_idConfigureRouteImport.update({
    id: "/builders/$builder_id/configure",
    path: "/builders/$builder_id/configure",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idOptionsRouteRoute =
  BuildersBuilder_idOptionsRouteRouteImport.update({
    id: "/builders/$builder_id/options",
    path: "/builders/$builder_id/options",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idEstimateRouteRoute =
  BuildersBuilder_idEstimateRouteRouteImport.update({
    id: "/builders/$builder_id/estimate",
    path: "/builders/$builder_id/estimate",
    getParentRoute: () => rootRouteImport,
  } as any)
const ShowroomPlanHome_plan_idIndexRoute =
  ShowroomPlanHome_plan_idIndexRouteImport.update({
    id: "/showroom/plan/$home_plan_id/",
    path: "/showroom/plan/$home_plan_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGeomMiterSkeletonIndexRoute =
  DebugGeomMiterSkeletonIndexRouteImport.update({
    id: "/debug/geom/miter-skeleton/",
    path: "/debug/geom/miter-skeleton/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idUsersIndexRoute =
  BuildersBuilder_idUsersIndexRouteImport.update({
    id: "/builders/$builder_id/users/",
    path: "/builders/$builder_id/users/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idTasksIndexRoute =
  BuildersBuilder_idTasksIndexRouteImport.update({
    id: "/builders/$builder_id/tasks/",
    path: "/builders/$builder_id/tasks/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idOptionsIndexRoute =
  BuildersBuilder_idOptionsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => BuildersBuilder_idOptionsRouteRoute,
  } as any)
const BuildersBuilder_idMasterPlansIndexRoute =
  BuildersBuilder_idMasterPlansIndexRouteImport.update({
    id: "/builders/$builder_id/master-plans/",
    path: "/builders/$builder_id/master-plans/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idMarketingIndexRoute =
  BuildersBuilder_idMarketingIndexRouteImport.update({
    id: "/builders/$builder_id/marketing/",
    path: "/builders/$builder_id/marketing/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsIndexRoute =
  BuildersBuilder_idLocationsIndexRouteImport.update({
    id: "/builders/$builder_id/locations/",
    path: "/builders/$builder_id/locations/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idIntegrationsIndexRoute =
  BuildersBuilder_idIntegrationsIndexRouteImport.update({
    id: "/builders/$builder_id/integrations/",
    path: "/builders/$builder_id/integrations/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idEstimateIndexRoute =
  BuildersBuilder_idEstimateIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => BuildersBuilder_idEstimateRouteRoute,
  } as any)
const BuildersBuilder_idDevelopersIndexRoute =
  BuildersBuilder_idDevelopersIndexRouteImport.update({
    id: "/builders/$builder_id/developers/",
    path: "/builders/$builder_id/developers/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idCommunitiesIndexRoute =
  BuildersBuilder_idCommunitiesIndexRouteImport.update({
    id: "/builders/$builder_id/communities/",
    path: "/builders/$builder_id/communities/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idAutoRendersIndexRoute =
  BuildersBuilder_idAutoRendersIndexRouteImport.update({
    id: "/builders/$builder_id/auto-renders/",
    path: "/builders/$builder_id/auto-renders/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idAccountIndexRoute =
  BuildersBuilder_idAccountIndexRouteImport.update({
    id: "/builders/$builder_id/account/",
    path: "/builders/$builder_id/account/",
    getParentRoute: () => rootRouteImport,
  } as any)
const ShowroomPlanHome_plan_idOverviewRoute =
  ShowroomPlanHome_plan_idOverviewRouteImport.update({
    id: "/showroom/plan/$home_plan_id/overview",
    path: "/showroom/plan/$home_plan_id/overview",
    getParentRoute: () => rootRouteImport,
  } as any)
const ShowroomPlanHome_plan_idOpsRoute =
  ShowroomPlanHome_plan_idOpsRouteImport.update({
    id: "/showroom/plan/$home_plan_id/ops",
    path: "/showroom/plan/$home_plan_id/ops",
    getParentRoute: () => rootRouteImport,
  } as any)
const DebugGeomMiterSkeletonSkeletonRoute =
  DebugGeomMiterSkeletonSkeletonRouteImport.update({
    id: "/debug/geom/miter-skeleton/skeleton",
    path: "/debug/geom/miter-skeleton/skeleton",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idProcureSplatRoute =
  BuildersBuilder_idProcureSplatRouteImport.update({
    id: "/builders/$builder_id/procure/$",
    path: "/builders/$builder_id/procure/$",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsNewRoute =
  BuildersBuilder_idLocationsNewRouteImport.update({
    id: "/builders/$builder_id/locations/new",
    path: "/builders/$builder_id/locations/new",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idTasksTask_idIndexRoute =
  BuildersBuilder_idTasksTask_idIndexRouteImport.update({
    id: "/builders/$builder_id/tasks/$task_id/",
    path: "/builders/$builder_id/tasks/$task_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute =
  BuildersBuilder_idMasterPlansMaster_plan_idIndexRouteImport.update({
    id: "/builders/$builder_id/master-plans/$master_plan_id/",
    path: "/builders/$builder_id/master-plans/$master_plan_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idIndexRoute =
  BuildersBuilder_idHomePlansHome_plan_idIndexRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/",
    path: "/builders/$builder_id/home-plans/$home_plan_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idEstimateIntegrationsIndexRoute =
  BuildersBuilder_idEstimateIntegrationsIndexRouteImport.update({
    id: "/integrations/",
    path: "/integrations/",
    getParentRoute: () => BuildersBuilder_idEstimateRouteRoute,
  } as any)
const BuildersBuilder_idAutoRendersItem_idIndexRoute =
  BuildersBuilder_idAutoRendersItem_idIndexRouteImport.update({
    id: "/builders/$builder_id/auto-renders/$item_id/",
    path: "/builders/$builder_id/auto-renders/$item_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idOptionsEditSetsRoute =
  BuildersBuilder_idOptionsEditSetsRouteImport.update({
    id: "/edit/sets",
    path: "/edit/sets",
    getParentRoute: () => BuildersBuilder_idOptionsRouteRoute,
  } as any)
const BuildersBuilder_idOptionsEditSetRoute =
  BuildersBuilder_idOptionsEditSetRouteImport.update({
    id: "/edit/set",
    path: "/edit/set",
    getParentRoute: () => BuildersBuilder_idOptionsRouteRoute,
  } as any)
const BuildersBuilder_idOptionsEditOptionsRoute =
  BuildersBuilder_idOptionsEditOptionsRouteImport.update({
    id: "/edit/options",
    path: "/edit/options",
    getParentRoute: () => BuildersBuilder_idOptionsRouteRoute,
  } as any)
const BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute =
  BuildersBuilder_idMasterPlansMaster_plan_idShowroomRouteImport.update({
    id: "/builders/$builder_id/master-plans/$master_plan_id/showroom",
    path: "/builders/$builder_id/master-plans/$master_plan_id/showroom",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute =
  BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRouteImport.update({
    id: "/builders/$builder_id/master-plans/$master_plan_id/sales-view",
    path: "/builders/$builder_id/master-plans/$master_plan_id/sales-view",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idHomePlansRoute =
  BuildersBuilder_idLocationsLocation_idHomePlansRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/home-plans",
    path: "/builders/$builder_id/locations/$location_id/home-plans",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idEditRoute =
  BuildersBuilder_idLocationsLocation_idEditRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/edit",
    path: "/builders/$builder_id/locations/$location_id/edit",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute =
  BuildersBuilder_idHomePlansHome_plan_idSalesViewRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/sales-view",
    path: "/builders/$builder_id/home-plans/$home_plan_id/sales-view",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute =
  BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/overview-internal",
    path: "/builders/$builder_id/home-plans/$home_plan_id/overview-internal",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idOverviewRoute =
  BuildersBuilder_idHomePlansHome_plan_idOverviewRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/overview",
    path: "/builders/$builder_id/home-plans/$home_plan_id/overview",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idEstimateIntegrationsResourcesRoute =
  BuildersBuilder_idEstimateIntegrationsResourcesRouteImport.update({
    id: "/integrations/resources",
    path: "/integrations/resources",
    getParentRoute: () => BuildersBuilder_idEstimateRouteRoute,
  } as any)
const BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute =
  BuildersBuilder_idEstimateIntegrationsCustomfieldsRouteImport.update({
    id: "/integrations/customfields",
    path: "/integrations/customfields",
    getParentRoute: () => BuildersBuilder_idEstimateRouteRoute,
  } as any)
const BuildersBuilder_idEstimateIntegrationsCostcodesRoute =
  BuildersBuilder_idEstimateIntegrationsCostcodesRouteImport.update({
    id: "/integrations/costcodes",
    path: "/integrations/costcodes",
    getParentRoute: () => BuildersBuilder_idEstimateRouteRoute,
  } as any)
const BuildersBuilder_idCommunitiesCommunity_idPlansRoute =
  BuildersBuilder_idCommunitiesCommunity_idPlansRouteImport.update({
    id: "/builders/$builder_id/communities/$community_id/plans",
    path: "/builders/$builder_id/communities/$community_id/plans",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idCommunitiesCommunity_idSplatRoute =
  BuildersBuilder_idCommunitiesCommunity_idSplatRouteImport.update({
    id: "/builders/$builder_id/communities/$community_id/$",
    path: "/builders/$builder_id/communities/$community_id/$",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute =
  DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRouteImport.update({
    id: "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/",
    path: "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoBuildersBuilder_nameSelectionsScene_idIndexRoute =
  DemoBuildersBuilder_nameSelectionsScene_idIndexRouteImport.update({
    id: "/demo/builders/$builder_name/selections/$scene_id/",
    path: "/demo/builders/$builder_name/selections/$scene_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute =
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRouteImport.update({
    id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/",
    path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute =
  BuildersBuilder_idLocationsLocation_idWorkbooksIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/workbooks/",
    path: "/builders/$builder_id/locations/$location_id/workbooks/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idTasksIndexRoute =
  BuildersBuilder_idLocationsLocation_idTasksIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/tasks/",
    path: "/builders/$builder_id/locations/$location_id/tasks/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute =
  BuildersBuilder_idLocationsLocation_idSubLocationsIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/sub-locations/",
    path: "/builders/$builder_id/locations/$location_id/sub-locations/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute =
  BuildersBuilder_idLocationsLocation_idStudioDocsIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/studio-docs/",
    path: "/builders/$builder_id/locations/$location_id/studio-docs/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute =
  BuildersBuilder_idLocationsLocation_idSalesMapIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/sales-map/",
    path: "/builders/$builder_id/locations/$location_id/sales-map/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idOptionsIndexRoute =
  BuildersBuilder_idLocationsLocation_idOptionsIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/options/",
    path: "/builders/$builder_id/locations/$location_id/options/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idMapIndexRoute =
  BuildersBuilder_idLocationsLocation_idMapIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/map/",
    path: "/builders/$builder_id/locations/$location_id/map/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idLotsIndexRoute =
  BuildersBuilder_idLocationsLocation_idLotsIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/lots/",
    path: "/builders/$builder_id/locations/$location_id/lots/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute =
  BuildersBuilder_idLocationsLocation_idLocationPlansIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/location-plans/",
    path: "/builders/$builder_id/locations/$location_id/location-plans/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute =
  BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/showroom/",
    path: "/builders/$builder_id/home-plans/$home_plan_id/showroom/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute =
  BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRouteImport.update({
    id: "/builders/$builder_id/home-plans/$home_plan_id/ops-view/",
    path: "/builders/$builder_id/home-plans/$home_plan_id/ops-view/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute =
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRouteImport.update(
    {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom",
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute =
  BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRouteImport.update({
    id: "/builders/$builder_id/locations/$location_id/lots/$lot_id/",
    path: "/builders/$builder_id/locations/$location_id/lots/$lot_id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute =
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRouteImport.update(
    {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/",
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute =
  BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRouteImport.update(
    {
      id: "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view",
      path: "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute =
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRouteImport.update(
    {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom",
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute =
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRouteImport.update(
    {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/",
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute =
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRouteImport.update(
    {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom",
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute =
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRouteImport.update(
    {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/",
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute =
  BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRouteImport.update(
    {
      id: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$",
      path: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$",
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute =
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRouteImport.update(
    {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom",
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom",
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/error": typeof ErrorRoute
  "/graphics-troubleshooting-test": typeof GraphicsTroubleshootingTestRoute
  "/intel-driver-bug-repro-2024": typeof IntelDriverBugRepro2024Route
  "/platform-diagnostics": typeof PlatformDiagnosticsRoute
  "/studio": typeof StudioRoute
  "/studio-sales-view": typeof StudioSalesViewRoute
  "/studio-showroom": typeof StudioShowroomRoute
  "/account/callback": typeof AccountCallbackRoute
  "/account/dashboard": typeof AccountDashboardRoute
  "/account/login": typeof AccountLoginRoute
  "/account/reset-password": typeof AccountResetPasswordRoute
  "/account/update-password": typeof AccountUpdatePasswordRoute
  "/admin/builders": typeof AdminBuildersRoute
  "/admin/debug": typeof AdminDebugRoute
  "/admin/features": typeof AdminFeaturesRoute
  "/admin/homes": typeof AdminHomesRoute
  "/admin/plan-analysis": typeof AdminPlanAnalysisRoute
  "/admin/selections": typeof AdminSelectionsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/users": typeof AdminUsersRoute
  "/debug/annotation": typeof DebugAnnotationRoute
  "/debug/building-debugger": typeof DebugBuildingDebuggerRoute
  "/debug/building-gltf": typeof DebugBuildingGltfRoute
  "/debug/building-gltf-lambda": typeof DebugBuildingGltfLambdaRoute
  "/debug/building-query": typeof DebugBuildingQueryRoute
  "/debug/building-renderer": typeof DebugBuildingRendererRoute
  "/debug/calibration-texture-test": typeof DebugCalibrationTextureTestRoute
  "/debug/compare-roof-viewer": typeof DebugCompareRoofViewerRoute
  "/debug/crash-test": typeof DebugCrashTestRoute
  "/debug/design-material": typeof DebugDesignMaterialRoute
  "/debug/design-material-docs": typeof DebugDesignMaterialDocsRoute
  "/debug/design-material-editor": typeof DebugDesignMaterialEditorRoute
  "/debug/error-403": typeof DebugError403Route
  "/debug/export": typeof DebugExportRoute
  "/debug/exr-test": typeof DebugExrTestRoute
  "/debug/exterior-scene": typeof DebugExteriorSceneRoute
  "/debug/face-diff-viewer": typeof DebugFaceDiffViewerRoute
  "/debug/hatch-material-generation": typeof DebugHatchMaterialGenerationRoute
  "/debug/hatching-test": typeof DebugHatchingTestRoute
  "/debug/iframe-test": typeof DebugIframeTestRoute
  "/debug/image-service": typeof DebugImageServiceRoute
  "/debug/material-appearance-test": typeof DebugMaterialAppearanceTestRoute
  "/debug/material-cache-manager": typeof DebugMaterialCacheManagerRoute
  "/debug/material-id": typeof DebugMaterialIdRoute
  "/debug/material-thumbnails": typeof DebugMaterialThumbnailsRoute
  "/debug/option-catalog-repair": typeof DebugOptionCatalogRepairRoute
  "/debug/palette-thumbnail-cache-bust": typeof DebugPaletteThumbnailCacheBustRoute
  "/debug/palette-thumbnail-test": typeof DebugPaletteThumbnailTestRoute
  "/debug/panorama-viewer": typeof DebugPanoramaViewerRoute
  "/debug/pdf-diff": typeof DebugPdfDiffRoute
  "/debug/plan-render": typeof DebugPlanRenderRoute
  "/debug/planar-graph": typeof DebugPlanarGraphRoute
  "/debug/prop-aws-admin": typeof DebugPropAwsAdminRoute
  "/debug/prop-aws-batch": typeof DebugPropAwsBatchRoute
  "/debug/props": typeof DebugPropsRoute
  "/debug/render": typeof DebugRenderRoute
  "/debug/repair-home": typeof DebugRepairHomeRoute
  "/debug/selections": typeof DebugSelectionsRoute
  "/debug/server-errors": typeof DebugServerErrorsRoute
  "/debug/showroom-floorplan": typeof DebugShowroomFloorplanRoute
  "/debug/showroom-gltf-import-performance": typeof DebugShowroomGltfImportPerformanceRoute
  "/debug/showroom-intro-performance": typeof DebugShowroomIntroPerformanceRoute
  "/debug/source-graph-analyzer": typeof DebugSourceGraphAnalyzerRoute
  "/debug/ssrr-test": typeof DebugSsrrTestRoute
  "/debug/stroke-test": typeof DebugStrokeTestRoute
  "/debug/svg-bb": typeof DebugSvgBbRoute
  "/debug/text-test": typeof DebugTextTestRoute
  "/debug/tonemapping-test": typeof DebugTonemappingTestRoute
  "/debug/viewer-state-management": typeof DebugViewerStateManagementRoute
  "/debug/walkthrough": typeof DebugWalkthroughRoute
  "/debug/walkthrough-caching": typeof DebugWalkthroughCachingRoute
  "/debug/wasm": typeof DebugWasmRoute
  "/debug/webgl-context-sharing": typeof DebugWebglContextSharingRoute
  "/debug/webgl-context-sharing-transform": typeof DebugWebglContextSharingTransformRoute
  "/debug/webgl-service": typeof DebugWebglServiceRoute
  "/demo/ibs-2023-selections": typeof DemoIbs2023SelectionsRoute
  "/demo/ibs-2023-start": typeof DemoIbs2023StartRoute
  "/demo/ibs-2023-walkthrough": typeof DemoIbs2023WalkthroughRoute
  "/demo/photoreal-interior360-TS21DMPO80M1": typeof DemoPhotorealInterior360TS21DMPO80M1Route
  "/demo/photoreal-selections": typeof DemoPhotorealSelectionsRoute
  "/demo/photoreal-selections360-WX34VCTU45P2": typeof DemoPhotorealSelections360WX34VCTU45P2Route
  "/demo/photoreal-walkthrough": typeof DemoPhotorealWalkthroughRoute
  "/demo/sheets": typeof DemoSheetsRoute
  "/demo/showroom": typeof DemoShowroomRoute
  "/invites/$invite_id": typeof InvitesInvite_idRoute
  "/showroom/intro": typeof ShowroomIntroRoute
  "/showroom/studio": typeof ShowroomStudioRoute
  "/admin/": typeof AdminIndexRoute
  "/debug/": typeof DebugIndexRoute
  "/showroom/": typeof ShowroomIndexRoute
  "/builders/$builder_id/estimate": typeof BuildersBuilder_idEstimateRouteRouteWithChildren
  "/builders/$builder_id/options": typeof BuildersBuilder_idOptionsRouteRouteWithChildren
  "/builders/$builder_id/configure": typeof BuildersBuilder_idConfigureRoute
  "/builders/$builder_id/files": typeof BuildersBuilder_idFilesRoute
  "/builders/$builder_id/guided-flow": typeof BuildersBuilder_idGuidedFlowRoute
  "/builders/$builder_id/plans": typeof BuildersBuilder_idPlansRoute
  "/debug/builder-website/sales-map": typeof DebugBuilderWebsiteSalesMapRoute
  "/debug/builder-website/showroom-intro": typeof DebugBuilderWebsiteShowroomIntroRoute
  "/debug/framing/truss2D": typeof DebugFramingTruss2DRoute
  "/debug/geom/straight-skeleton-offset": typeof DebugGeomStraightSkeletonOffsetRoute
  "/debug/geom/straight-skeleton-offset-single": typeof DebugGeomStraightSkeletonOffsetSingleRoute
  "/debug/gfx-stress/geometry-stress-incremental": typeof DebugGfxStressGeometryStressIncrementalRoute
  "/debug/gfx-stress/material-stress": typeof DebugGfxStressMaterialStressRoute
  "/debug/gfx-stress/material-stress-incremental": typeof DebugGfxStressMaterialStressIncrementalRoute
  "/debug/gfx-test/material-render": typeof DebugGfxTestMaterialRenderRoute
  "/debug/gfx-test/threeviewer-init": typeof DebugGfxTestThreeviewerInitRoute
  "/debug/option-migration/migrate-options": typeof DebugOptionMigrationMigrateOptionsRoute
  "/debug/polyclip/brep-set-ops-test": typeof DebugPolyclipBrepSetOpsTestRoute
  "/debug/polyclip/brep-trim-test": typeof DebugPolyclipBrepTrimTestRoute
  "/debug/polyclip/offset-closed-test": typeof DebugPolyclipOffsetClosedTestRoute
  "/debug/polyclip/plane-trim-test": typeof DebugPolyclipPlaneTrimTestRoute
  "/debug/polyclip/set-ops-bench": typeof DebugPolyclipSetOpsBenchRoute
  "/debug/polyclip/set-ops-fuzz": typeof DebugPolyclipSetOpsFuzzRoute
  "/debug/polyclip/set-ops-test": typeof DebugPolyclipSetOpsTestRoute
  "/debug/polyclip/snap-round-test": typeof DebugPolyclipSnapRoundTestRoute
  "/debug/polyclip/trim-faces-test": typeof DebugPolyclipTrimFacesTestRoute
  "/debug/schema/bapi-kams": typeof DebugSchemaBapiKamsRoute
  "/debug/schema/building-api": typeof DebugSchemaBuildingApiRoute
  "/demo/connected/bigscreen": typeof DemoConnectedBigscreenRoute
  "/demo/connected/showroom": typeof DemoConnectedShowroomRoute
  "/demo/connected/singlescreen": typeof DemoConnectedSinglescreenRoute
  "/demo/connected/tabs": typeof DemoConnectedTabsRoute
  "/showroom/edit/intro": typeof ShowroomEditIntroRoute
  "/admin/component-library/": typeof AdminComponentLibraryIndexRoute
  "/admin/data-migration/": typeof AdminDataMigrationIndexRoute
  "/builders/$builder_id/": typeof BuildersBuilder_idIndexRoute
  "/debug/builder-website/": typeof DebugBuilderWebsiteIndexRoute
  "/debug/floor-framing/": typeof DebugFloorFramingIndexRoute
  "/debug/geom/": typeof DebugGeomIndexRoute
  "/debug/option-migration/": typeof DebugOptionMigrationIndexRoute
  "/debug/wall-framing/": typeof DebugWallFramingIndexRoute
  "/demo/connected/": typeof DemoConnectedIndexRoute
  "/builders/$builder_id/locations/new": typeof BuildersBuilder_idLocationsNewRoute
  "/builders/$builder_id/procure/$": typeof BuildersBuilder_idProcureSplatRoute
  "/debug/geom/miter-skeleton/skeleton": typeof DebugGeomMiterSkeletonSkeletonRoute
  "/showroom/plan/$home_plan_id/ops": typeof ShowroomPlanHome_plan_idOpsRoute
  "/showroom/plan/$home_plan_id/overview": typeof ShowroomPlanHome_plan_idOverviewRoute
  "/builders/$builder_id/account/": typeof BuildersBuilder_idAccountIndexRoute
  "/builders/$builder_id/auto-renders/": typeof BuildersBuilder_idAutoRendersIndexRoute
  "/builders/$builder_id/communities/": typeof BuildersBuilder_idCommunitiesIndexRoute
  "/builders/$builder_id/developers/": typeof BuildersBuilder_idDevelopersIndexRoute
  "/builders/$builder_id/estimate/": typeof BuildersBuilder_idEstimateIndexRoute
  "/builders/$builder_id/integrations/": typeof BuildersBuilder_idIntegrationsIndexRoute
  "/builders/$builder_id/locations/": typeof BuildersBuilder_idLocationsIndexRoute
  "/builders/$builder_id/marketing/": typeof BuildersBuilder_idMarketingIndexRoute
  "/builders/$builder_id/master-plans/": typeof BuildersBuilder_idMasterPlansIndexRoute
  "/builders/$builder_id/options/": typeof BuildersBuilder_idOptionsIndexRoute
  "/builders/$builder_id/tasks/": typeof BuildersBuilder_idTasksIndexRoute
  "/builders/$builder_id/users/": typeof BuildersBuilder_idUsersIndexRoute
  "/debug/geom/miter-skeleton/": typeof DebugGeomMiterSkeletonIndexRoute
  "/showroom/plan/$home_plan_id/": typeof ShowroomPlanHome_plan_idIndexRoute
  "/builders/$builder_id/communities/$community_id/$": typeof BuildersBuilder_idCommunitiesCommunity_idSplatRoute
  "/builders/$builder_id/communities/$community_id/plans": typeof BuildersBuilder_idCommunitiesCommunity_idPlansRoute
  "/builders/$builder_id/estimate/integrations/costcodes": typeof BuildersBuilder_idEstimateIntegrationsCostcodesRoute
  "/builders/$builder_id/estimate/integrations/customfields": typeof BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute
  "/builders/$builder_id/estimate/integrations/resources": typeof BuildersBuilder_idEstimateIntegrationsResourcesRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview-internal": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute
  "/builders/$builder_id/home-plans/$home_plan_id/sales-view": typeof BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/edit": typeof BuildersBuilder_idLocationsLocation_idEditRoute
  "/builders/$builder_id/locations/$location_id/home-plans": typeof BuildersBuilder_idLocationsLocation_idHomePlansRoute
  "/builders/$builder_id/master-plans/$master_plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute
  "/builders/$builder_id/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/options/edit/options": typeof BuildersBuilder_idOptionsEditOptionsRoute
  "/builders/$builder_id/options/edit/set": typeof BuildersBuilder_idOptionsEditSetRoute
  "/builders/$builder_id/options/edit/sets": typeof BuildersBuilder_idOptionsEditSetsRoute
  "/builders/$builder_id/auto-renders/$item_id/": typeof BuildersBuilder_idAutoRendersItem_idIndexRoute
  "/builders/$builder_id/estimate/integrations/": typeof BuildersBuilder_idEstimateIntegrationsIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id/": typeof BuildersBuilder_idHomePlansHome_plan_idIndexRoute
  "/builders/$builder_id/master-plans/$master_plan_id/": typeof BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute
  "/builders/$builder_id/tasks/$task_id/": typeof BuildersBuilder_idTasksTask_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/home-plans/$home_plan_id/ops-view/": typeof BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id/showroom/": typeof BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute
  "/builders/$builder_id/locations/$location_id/lots/": typeof BuildersBuilder_idLocationsLocation_idLotsIndexRoute
  "/builders/$builder_id/locations/$location_id/map/": typeof BuildersBuilder_idLocationsLocation_idMapIndexRoute
  "/builders/$builder_id/locations/$location_id/options/": typeof BuildersBuilder_idLocationsLocation_idOptionsIndexRoute
  "/builders/$builder_id/locations/$location_id/sales-map/": typeof BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute
  "/builders/$builder_id/locations/$location_id/studio-docs/": typeof BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute
  "/builders/$builder_id/locations/$location_id/sub-locations/": typeof BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute
  "/builders/$builder_id/locations/$location_id/tasks/": typeof BuildersBuilder_idLocationsLocation_idTasksIndexRoute
  "/builders/$builder_id/locations/$location_id/workbooks/": typeof BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute
  "/demo/builders/$builder_name/selections/$scene_id/": typeof DemoBuildersBuilder_nameSelectionsScene_idIndexRoute
  "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/": typeof DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/lots/$lot_id/": typeof BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/error": typeof ErrorRoute
  "/graphics-troubleshooting-test": typeof GraphicsTroubleshootingTestRoute
  "/intel-driver-bug-repro-2024": typeof IntelDriverBugRepro2024Route
  "/platform-diagnostics": typeof PlatformDiagnosticsRoute
  "/studio": typeof StudioRoute
  "/studio-sales-view": typeof StudioSalesViewRoute
  "/studio-showroom": typeof StudioShowroomRoute
  "/account/callback": typeof AccountCallbackRoute
  "/account/dashboard": typeof AccountDashboardRoute
  "/account/login": typeof AccountLoginRoute
  "/account/reset-password": typeof AccountResetPasswordRoute
  "/account/update-password": typeof AccountUpdatePasswordRoute
  "/admin/builders": typeof AdminBuildersRoute
  "/admin/debug": typeof AdminDebugRoute
  "/admin/features": typeof AdminFeaturesRoute
  "/admin/homes": typeof AdminHomesRoute
  "/admin/plan-analysis": typeof AdminPlanAnalysisRoute
  "/admin/selections": typeof AdminSelectionsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/users": typeof AdminUsersRoute
  "/debug/annotation": typeof DebugAnnotationRoute
  "/debug/building-debugger": typeof DebugBuildingDebuggerRoute
  "/debug/building-gltf": typeof DebugBuildingGltfRoute
  "/debug/building-gltf-lambda": typeof DebugBuildingGltfLambdaRoute
  "/debug/building-query": typeof DebugBuildingQueryRoute
  "/debug/building-renderer": typeof DebugBuildingRendererRoute
  "/debug/calibration-texture-test": typeof DebugCalibrationTextureTestRoute
  "/debug/compare-roof-viewer": typeof DebugCompareRoofViewerRoute
  "/debug/crash-test": typeof DebugCrashTestRoute
  "/debug/design-material": typeof DebugDesignMaterialRoute
  "/debug/design-material-docs": typeof DebugDesignMaterialDocsRoute
  "/debug/design-material-editor": typeof DebugDesignMaterialEditorRoute
  "/debug/error-403": typeof DebugError403Route
  "/debug/export": typeof DebugExportRoute
  "/debug/exr-test": typeof DebugExrTestRoute
  "/debug/exterior-scene": typeof DebugExteriorSceneRoute
  "/debug/face-diff-viewer": typeof DebugFaceDiffViewerRoute
  "/debug/hatch-material-generation": typeof DebugHatchMaterialGenerationRoute
  "/debug/hatching-test": typeof DebugHatchingTestRoute
  "/debug/iframe-test": typeof DebugIframeTestRoute
  "/debug/image-service": typeof DebugImageServiceRoute
  "/debug/material-appearance-test": typeof DebugMaterialAppearanceTestRoute
  "/debug/material-cache-manager": typeof DebugMaterialCacheManagerRoute
  "/debug/material-id": typeof DebugMaterialIdRoute
  "/debug/material-thumbnails": typeof DebugMaterialThumbnailsRoute
  "/debug/option-catalog-repair": typeof DebugOptionCatalogRepairRoute
  "/debug/palette-thumbnail-cache-bust": typeof DebugPaletteThumbnailCacheBustRoute
  "/debug/palette-thumbnail-test": typeof DebugPaletteThumbnailTestRoute
  "/debug/panorama-viewer": typeof DebugPanoramaViewerRoute
  "/debug/pdf-diff": typeof DebugPdfDiffRoute
  "/debug/plan-render": typeof DebugPlanRenderRoute
  "/debug/planar-graph": typeof DebugPlanarGraphRoute
  "/debug/prop-aws-admin": typeof DebugPropAwsAdminRoute
  "/debug/prop-aws-batch": typeof DebugPropAwsBatchRoute
  "/debug/props": typeof DebugPropsRoute
  "/debug/render": typeof DebugRenderRoute
  "/debug/repair-home": typeof DebugRepairHomeRoute
  "/debug/selections": typeof DebugSelectionsRoute
  "/debug/server-errors": typeof DebugServerErrorsRoute
  "/debug/showroom-floorplan": typeof DebugShowroomFloorplanRoute
  "/debug/showroom-gltf-import-performance": typeof DebugShowroomGltfImportPerformanceRoute
  "/debug/showroom-intro-performance": typeof DebugShowroomIntroPerformanceRoute
  "/debug/source-graph-analyzer": typeof DebugSourceGraphAnalyzerRoute
  "/debug/ssrr-test": typeof DebugSsrrTestRoute
  "/debug/stroke-test": typeof DebugStrokeTestRoute
  "/debug/svg-bb": typeof DebugSvgBbRoute
  "/debug/text-test": typeof DebugTextTestRoute
  "/debug/tonemapping-test": typeof DebugTonemappingTestRoute
  "/debug/viewer-state-management": typeof DebugViewerStateManagementRoute
  "/debug/walkthrough": typeof DebugWalkthroughRoute
  "/debug/walkthrough-caching": typeof DebugWalkthroughCachingRoute
  "/debug/wasm": typeof DebugWasmRoute
  "/debug/webgl-context-sharing": typeof DebugWebglContextSharingRoute
  "/debug/webgl-context-sharing-transform": typeof DebugWebglContextSharingTransformRoute
  "/debug/webgl-service": typeof DebugWebglServiceRoute
  "/demo/ibs-2023-selections": typeof DemoIbs2023SelectionsRoute
  "/demo/ibs-2023-start": typeof DemoIbs2023StartRoute
  "/demo/ibs-2023-walkthrough": typeof DemoIbs2023WalkthroughRoute
  "/demo/photoreal-interior360-TS21DMPO80M1": typeof DemoPhotorealInterior360TS21DMPO80M1Route
  "/demo/photoreal-selections": typeof DemoPhotorealSelectionsRoute
  "/demo/photoreal-selections360-WX34VCTU45P2": typeof DemoPhotorealSelections360WX34VCTU45P2Route
  "/demo/photoreal-walkthrough": typeof DemoPhotorealWalkthroughRoute
  "/demo/sheets": typeof DemoSheetsRoute
  "/demo/showroom": typeof DemoShowroomRoute
  "/invites/$invite_id": typeof InvitesInvite_idRoute
  "/showroom/intro": typeof ShowroomIntroRoute
  "/showroom/studio": typeof ShowroomStudioRoute
  "/admin": typeof AdminIndexRoute
  "/debug": typeof DebugIndexRoute
  "/showroom": typeof ShowroomIndexRoute
  "/builders/$builder_id/configure": typeof BuildersBuilder_idConfigureRoute
  "/builders/$builder_id/files": typeof BuildersBuilder_idFilesRoute
  "/builders/$builder_id/guided-flow": typeof BuildersBuilder_idGuidedFlowRoute
  "/builders/$builder_id/plans": typeof BuildersBuilder_idPlansRoute
  "/debug/builder-website/sales-map": typeof DebugBuilderWebsiteSalesMapRoute
  "/debug/builder-website/showroom-intro": typeof DebugBuilderWebsiteShowroomIntroRoute
  "/debug/framing/truss2D": typeof DebugFramingTruss2DRoute
  "/debug/geom/straight-skeleton-offset": typeof DebugGeomStraightSkeletonOffsetRoute
  "/debug/geom/straight-skeleton-offset-single": typeof DebugGeomStraightSkeletonOffsetSingleRoute
  "/debug/gfx-stress/geometry-stress-incremental": typeof DebugGfxStressGeometryStressIncrementalRoute
  "/debug/gfx-stress/material-stress": typeof DebugGfxStressMaterialStressRoute
  "/debug/gfx-stress/material-stress-incremental": typeof DebugGfxStressMaterialStressIncrementalRoute
  "/debug/gfx-test/material-render": typeof DebugGfxTestMaterialRenderRoute
  "/debug/gfx-test/threeviewer-init": typeof DebugGfxTestThreeviewerInitRoute
  "/debug/option-migration/migrate-options": typeof DebugOptionMigrationMigrateOptionsRoute
  "/debug/polyclip/brep-set-ops-test": typeof DebugPolyclipBrepSetOpsTestRoute
  "/debug/polyclip/brep-trim-test": typeof DebugPolyclipBrepTrimTestRoute
  "/debug/polyclip/offset-closed-test": typeof DebugPolyclipOffsetClosedTestRoute
  "/debug/polyclip/plane-trim-test": typeof DebugPolyclipPlaneTrimTestRoute
  "/debug/polyclip/set-ops-bench": typeof DebugPolyclipSetOpsBenchRoute
  "/debug/polyclip/set-ops-fuzz": typeof DebugPolyclipSetOpsFuzzRoute
  "/debug/polyclip/set-ops-test": typeof DebugPolyclipSetOpsTestRoute
  "/debug/polyclip/snap-round-test": typeof DebugPolyclipSnapRoundTestRoute
  "/debug/polyclip/trim-faces-test": typeof DebugPolyclipTrimFacesTestRoute
  "/debug/schema/bapi-kams": typeof DebugSchemaBapiKamsRoute
  "/debug/schema/building-api": typeof DebugSchemaBuildingApiRoute
  "/demo/connected/bigscreen": typeof DemoConnectedBigscreenRoute
  "/demo/connected/showroom": typeof DemoConnectedShowroomRoute
  "/demo/connected/singlescreen": typeof DemoConnectedSinglescreenRoute
  "/demo/connected/tabs": typeof DemoConnectedTabsRoute
  "/showroom/edit/intro": typeof ShowroomEditIntroRoute
  "/admin/component-library": typeof AdminComponentLibraryIndexRoute
  "/admin/data-migration": typeof AdminDataMigrationIndexRoute
  "/builders/$builder_id": typeof BuildersBuilder_idIndexRoute
  "/debug/builder-website": typeof DebugBuilderWebsiteIndexRoute
  "/debug/floor-framing": typeof DebugFloorFramingIndexRoute
  "/debug/geom": typeof DebugGeomIndexRoute
  "/debug/option-migration": typeof DebugOptionMigrationIndexRoute
  "/debug/wall-framing": typeof DebugWallFramingIndexRoute
  "/demo/connected": typeof DemoConnectedIndexRoute
  "/builders/$builder_id/locations/new": typeof BuildersBuilder_idLocationsNewRoute
  "/builders/$builder_id/procure/$": typeof BuildersBuilder_idProcureSplatRoute
  "/debug/geom/miter-skeleton/skeleton": typeof DebugGeomMiterSkeletonSkeletonRoute
  "/showroom/plan/$home_plan_id/ops": typeof ShowroomPlanHome_plan_idOpsRoute
  "/showroom/plan/$home_plan_id/overview": typeof ShowroomPlanHome_plan_idOverviewRoute
  "/builders/$builder_id/account": typeof BuildersBuilder_idAccountIndexRoute
  "/builders/$builder_id/auto-renders": typeof BuildersBuilder_idAutoRendersIndexRoute
  "/builders/$builder_id/communities": typeof BuildersBuilder_idCommunitiesIndexRoute
  "/builders/$builder_id/developers": typeof BuildersBuilder_idDevelopersIndexRoute
  "/builders/$builder_id/estimate": typeof BuildersBuilder_idEstimateIndexRoute
  "/builders/$builder_id/integrations": typeof BuildersBuilder_idIntegrationsIndexRoute
  "/builders/$builder_id/locations": typeof BuildersBuilder_idLocationsIndexRoute
  "/builders/$builder_id/marketing": typeof BuildersBuilder_idMarketingIndexRoute
  "/builders/$builder_id/master-plans": typeof BuildersBuilder_idMasterPlansIndexRoute
  "/builders/$builder_id/options": typeof BuildersBuilder_idOptionsIndexRoute
  "/builders/$builder_id/tasks": typeof BuildersBuilder_idTasksIndexRoute
  "/builders/$builder_id/users": typeof BuildersBuilder_idUsersIndexRoute
  "/debug/geom/miter-skeleton": typeof DebugGeomMiterSkeletonIndexRoute
  "/showroom/plan/$home_plan_id": typeof ShowroomPlanHome_plan_idIndexRoute
  "/builders/$builder_id/communities/$community_id/$": typeof BuildersBuilder_idCommunitiesCommunity_idSplatRoute
  "/builders/$builder_id/communities/$community_id/plans": typeof BuildersBuilder_idCommunitiesCommunity_idPlansRoute
  "/builders/$builder_id/estimate/integrations/costcodes": typeof BuildersBuilder_idEstimateIntegrationsCostcodesRoute
  "/builders/$builder_id/estimate/integrations/customfields": typeof BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute
  "/builders/$builder_id/estimate/integrations/resources": typeof BuildersBuilder_idEstimateIntegrationsResourcesRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview-internal": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute
  "/builders/$builder_id/home-plans/$home_plan_id/sales-view": typeof BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/edit": typeof BuildersBuilder_idLocationsLocation_idEditRoute
  "/builders/$builder_id/locations/$location_id/home-plans": typeof BuildersBuilder_idLocationsLocation_idHomePlansRoute
  "/builders/$builder_id/master-plans/$master_plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute
  "/builders/$builder_id/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/options/edit/options": typeof BuildersBuilder_idOptionsEditOptionsRoute
  "/builders/$builder_id/options/edit/set": typeof BuildersBuilder_idOptionsEditSetRoute
  "/builders/$builder_id/options/edit/sets": typeof BuildersBuilder_idOptionsEditSetsRoute
  "/builders/$builder_id/auto-renders/$item_id": typeof BuildersBuilder_idAutoRendersItem_idIndexRoute
  "/builders/$builder_id/estimate/integrations": typeof BuildersBuilder_idEstimateIntegrationsIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id": typeof BuildersBuilder_idHomePlansHome_plan_idIndexRoute
  "/builders/$builder_id/master-plans/$master_plan_id": typeof BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute
  "/builders/$builder_id/tasks/$task_id": typeof BuildersBuilder_idTasksTask_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/home-plans/$home_plan_id/ops-view": typeof BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id/showroom": typeof BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans": typeof BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute
  "/builders/$builder_id/locations/$location_id/lots": typeof BuildersBuilder_idLocationsLocation_idLotsIndexRoute
  "/builders/$builder_id/locations/$location_id/map": typeof BuildersBuilder_idLocationsLocation_idMapIndexRoute
  "/builders/$builder_id/locations/$location_id/options": typeof BuildersBuilder_idLocationsLocation_idOptionsIndexRoute
  "/builders/$builder_id/locations/$location_id/sales-map": typeof BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute
  "/builders/$builder_id/locations/$location_id/studio-docs": typeof BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute
  "/builders/$builder_id/locations/$location_id/sub-locations": typeof BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute
  "/builders/$builder_id/locations/$location_id/tasks": typeof BuildersBuilder_idLocationsLocation_idTasksIndexRoute
  "/builders/$builder_id/locations/$location_id/workbooks": typeof BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute
  "/demo/builders/$builder_name/selections/$scene_id": typeof DemoBuildersBuilder_nameSelectionsScene_idIndexRoute
  "/demo/builders/$builder_name/walkthroughs/$walkthrough_id": typeof DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/lots/$lot_id": typeof BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/404": typeof R404Route
  "/error": typeof ErrorRoute
  "/graphics-troubleshooting-test": typeof GraphicsTroubleshootingTestRoute
  "/intel-driver-bug-repro-2024": typeof IntelDriverBugRepro2024Route
  "/platform-diagnostics": typeof PlatformDiagnosticsRoute
  "/studio": typeof StudioRoute
  "/studio-sales-view": typeof StudioSalesViewRoute
  "/studio-showroom": typeof StudioShowroomRoute
  "/account/callback": typeof AccountCallbackRoute
  "/account/dashboard": typeof AccountDashboardRoute
  "/account/login": typeof AccountLoginRoute
  "/account/reset-password": typeof AccountResetPasswordRoute
  "/account/update-password": typeof AccountUpdatePasswordRoute
  "/admin/builders": typeof AdminBuildersRoute
  "/admin/debug": typeof AdminDebugRoute
  "/admin/features": typeof AdminFeaturesRoute
  "/admin/homes": typeof AdminHomesRoute
  "/admin/plan-analysis": typeof AdminPlanAnalysisRoute
  "/admin/selections": typeof AdminSelectionsRoute
  "/admin/settings": typeof AdminSettingsRoute
  "/admin/users": typeof AdminUsersRoute
  "/debug/annotation": typeof DebugAnnotationRoute
  "/debug/building-debugger": typeof DebugBuildingDebuggerRoute
  "/debug/building-gltf": typeof DebugBuildingGltfRoute
  "/debug/building-gltf-lambda": typeof DebugBuildingGltfLambdaRoute
  "/debug/building-query": typeof DebugBuildingQueryRoute
  "/debug/building-renderer": typeof DebugBuildingRendererRoute
  "/debug/calibration-texture-test": typeof DebugCalibrationTextureTestRoute
  "/debug/compare-roof-viewer": typeof DebugCompareRoofViewerRoute
  "/debug/crash-test": typeof DebugCrashTestRoute
  "/debug/design-material": typeof DebugDesignMaterialRoute
  "/debug/design-material-docs": typeof DebugDesignMaterialDocsRoute
  "/debug/design-material-editor": typeof DebugDesignMaterialEditorRoute
  "/debug/error-403": typeof DebugError403Route
  "/debug/export": typeof DebugExportRoute
  "/debug/exr-test": typeof DebugExrTestRoute
  "/debug/exterior-scene": typeof DebugExteriorSceneRoute
  "/debug/face-diff-viewer": typeof DebugFaceDiffViewerRoute
  "/debug/hatch-material-generation": typeof DebugHatchMaterialGenerationRoute
  "/debug/hatching-test": typeof DebugHatchingTestRoute
  "/debug/iframe-test": typeof DebugIframeTestRoute
  "/debug/image-service": typeof DebugImageServiceRoute
  "/debug/material-appearance-test": typeof DebugMaterialAppearanceTestRoute
  "/debug/material-cache-manager": typeof DebugMaterialCacheManagerRoute
  "/debug/material-id": typeof DebugMaterialIdRoute
  "/debug/material-thumbnails": typeof DebugMaterialThumbnailsRoute
  "/debug/option-catalog-repair": typeof DebugOptionCatalogRepairRoute
  "/debug/palette-thumbnail-cache-bust": typeof DebugPaletteThumbnailCacheBustRoute
  "/debug/palette-thumbnail-test": typeof DebugPaletteThumbnailTestRoute
  "/debug/panorama-viewer": typeof DebugPanoramaViewerRoute
  "/debug/pdf-diff": typeof DebugPdfDiffRoute
  "/debug/plan-render": typeof DebugPlanRenderRoute
  "/debug/planar-graph": typeof DebugPlanarGraphRoute
  "/debug/prop-aws-admin": typeof DebugPropAwsAdminRoute
  "/debug/prop-aws-batch": typeof DebugPropAwsBatchRoute
  "/debug/props": typeof DebugPropsRoute
  "/debug/render": typeof DebugRenderRoute
  "/debug/repair-home": typeof DebugRepairHomeRoute
  "/debug/selections": typeof DebugSelectionsRoute
  "/debug/server-errors": typeof DebugServerErrorsRoute
  "/debug/showroom-floorplan": typeof DebugShowroomFloorplanRoute
  "/debug/showroom-gltf-import-performance": typeof DebugShowroomGltfImportPerformanceRoute
  "/debug/showroom-intro-performance": typeof DebugShowroomIntroPerformanceRoute
  "/debug/source-graph-analyzer": typeof DebugSourceGraphAnalyzerRoute
  "/debug/ssrr-test": typeof DebugSsrrTestRoute
  "/debug/stroke-test": typeof DebugStrokeTestRoute
  "/debug/svg-bb": typeof DebugSvgBbRoute
  "/debug/text-test": typeof DebugTextTestRoute
  "/debug/tonemapping-test": typeof DebugTonemappingTestRoute
  "/debug/viewer-state-management": typeof DebugViewerStateManagementRoute
  "/debug/walkthrough": typeof DebugWalkthroughRoute
  "/debug/walkthrough-caching": typeof DebugWalkthroughCachingRoute
  "/debug/wasm": typeof DebugWasmRoute
  "/debug/webgl-context-sharing": typeof DebugWebglContextSharingRoute
  "/debug/webgl-context-sharing-transform": typeof DebugWebglContextSharingTransformRoute
  "/debug/webgl-service": typeof DebugWebglServiceRoute
  "/demo/ibs-2023-selections": typeof DemoIbs2023SelectionsRoute
  "/demo/ibs-2023-start": typeof DemoIbs2023StartRoute
  "/demo/ibs-2023-walkthrough": typeof DemoIbs2023WalkthroughRoute
  "/demo/photoreal-interior360-TS21DMPO80M1": typeof DemoPhotorealInterior360TS21DMPO80M1Route
  "/demo/photoreal-selections": typeof DemoPhotorealSelectionsRoute
  "/demo/photoreal-selections360-WX34VCTU45P2": typeof DemoPhotorealSelections360WX34VCTU45P2Route
  "/demo/photoreal-walkthrough": typeof DemoPhotorealWalkthroughRoute
  "/demo/sheets": typeof DemoSheetsRoute
  "/demo/showroom": typeof DemoShowroomRoute
  "/invites/$invite_id": typeof InvitesInvite_idRoute
  "/showroom/intro": typeof ShowroomIntroRoute
  "/showroom/studio": typeof ShowroomStudioRoute
  "/admin/": typeof AdminIndexRoute
  "/debug/": typeof DebugIndexRoute
  "/showroom/": typeof ShowroomIndexRoute
  "/builders/$builder_id/estimate": typeof BuildersBuilder_idEstimateRouteRouteWithChildren
  "/builders/$builder_id/options": typeof BuildersBuilder_idOptionsRouteRouteWithChildren
  "/builders/$builder_id/configure": typeof BuildersBuilder_idConfigureRoute
  "/builders/$builder_id/files": typeof BuildersBuilder_idFilesRoute
  "/builders/$builder_id/guided-flow": typeof BuildersBuilder_idGuidedFlowRoute
  "/builders/$builder_id/plans": typeof BuildersBuilder_idPlansRoute
  "/debug/builder-website/sales-map": typeof DebugBuilderWebsiteSalesMapRoute
  "/debug/builder-website/showroom-intro": typeof DebugBuilderWebsiteShowroomIntroRoute
  "/debug/framing/truss2D": typeof DebugFramingTruss2DRoute
  "/debug/geom/straight-skeleton-offset": typeof DebugGeomStraightSkeletonOffsetRoute
  "/debug/geom/straight-skeleton-offset-single": typeof DebugGeomStraightSkeletonOffsetSingleRoute
  "/debug/gfx-stress/geometry-stress-incremental": typeof DebugGfxStressGeometryStressIncrementalRoute
  "/debug/gfx-stress/material-stress": typeof DebugGfxStressMaterialStressRoute
  "/debug/gfx-stress/material-stress-incremental": typeof DebugGfxStressMaterialStressIncrementalRoute
  "/debug/gfx-test/material-render": typeof DebugGfxTestMaterialRenderRoute
  "/debug/gfx-test/threeviewer-init": typeof DebugGfxTestThreeviewerInitRoute
  "/debug/option-migration/migrate-options": typeof DebugOptionMigrationMigrateOptionsRoute
  "/debug/polyclip/brep-set-ops-test": typeof DebugPolyclipBrepSetOpsTestRoute
  "/debug/polyclip/brep-trim-test": typeof DebugPolyclipBrepTrimTestRoute
  "/debug/polyclip/offset-closed-test": typeof DebugPolyclipOffsetClosedTestRoute
  "/debug/polyclip/plane-trim-test": typeof DebugPolyclipPlaneTrimTestRoute
  "/debug/polyclip/set-ops-bench": typeof DebugPolyclipSetOpsBenchRoute
  "/debug/polyclip/set-ops-fuzz": typeof DebugPolyclipSetOpsFuzzRoute
  "/debug/polyclip/set-ops-test": typeof DebugPolyclipSetOpsTestRoute
  "/debug/polyclip/snap-round-test": typeof DebugPolyclipSnapRoundTestRoute
  "/debug/polyclip/trim-faces-test": typeof DebugPolyclipTrimFacesTestRoute
  "/debug/schema/bapi-kams": typeof DebugSchemaBapiKamsRoute
  "/debug/schema/building-api": typeof DebugSchemaBuildingApiRoute
  "/demo/connected/bigscreen": typeof DemoConnectedBigscreenRoute
  "/demo/connected/showroom": typeof DemoConnectedShowroomRoute
  "/demo/connected/singlescreen": typeof DemoConnectedSinglescreenRoute
  "/demo/connected/tabs": typeof DemoConnectedTabsRoute
  "/showroom/edit/intro": typeof ShowroomEditIntroRoute
  "/admin/component-library/": typeof AdminComponentLibraryIndexRoute
  "/admin/data-migration/": typeof AdminDataMigrationIndexRoute
  "/builders/$builder_id/": typeof BuildersBuilder_idIndexRoute
  "/debug/builder-website/": typeof DebugBuilderWebsiteIndexRoute
  "/debug/floor-framing/": typeof DebugFloorFramingIndexRoute
  "/debug/geom/": typeof DebugGeomIndexRoute
  "/debug/option-migration/": typeof DebugOptionMigrationIndexRoute
  "/debug/wall-framing/": typeof DebugWallFramingIndexRoute
  "/demo/connected/": typeof DemoConnectedIndexRoute
  "/builders/$builder_id/locations/new": typeof BuildersBuilder_idLocationsNewRoute
  "/builders/$builder_id/procure/$": typeof BuildersBuilder_idProcureSplatRoute
  "/debug/geom/miter-skeleton/skeleton": typeof DebugGeomMiterSkeletonSkeletonRoute
  "/showroom/plan/$home_plan_id/ops": typeof ShowroomPlanHome_plan_idOpsRoute
  "/showroom/plan/$home_plan_id/overview": typeof ShowroomPlanHome_plan_idOverviewRoute
  "/builders/$builder_id/account/": typeof BuildersBuilder_idAccountIndexRoute
  "/builders/$builder_id/auto-renders/": typeof BuildersBuilder_idAutoRendersIndexRoute
  "/builders/$builder_id/communities/": typeof BuildersBuilder_idCommunitiesIndexRoute
  "/builders/$builder_id/developers/": typeof BuildersBuilder_idDevelopersIndexRoute
  "/builders/$builder_id/estimate/": typeof BuildersBuilder_idEstimateIndexRoute
  "/builders/$builder_id/integrations/": typeof BuildersBuilder_idIntegrationsIndexRoute
  "/builders/$builder_id/locations/": typeof BuildersBuilder_idLocationsIndexRoute
  "/builders/$builder_id/marketing/": typeof BuildersBuilder_idMarketingIndexRoute
  "/builders/$builder_id/master-plans/": typeof BuildersBuilder_idMasterPlansIndexRoute
  "/builders/$builder_id/options/": typeof BuildersBuilder_idOptionsIndexRoute
  "/builders/$builder_id/tasks/": typeof BuildersBuilder_idTasksIndexRoute
  "/builders/$builder_id/users/": typeof BuildersBuilder_idUsersIndexRoute
  "/debug/geom/miter-skeleton/": typeof DebugGeomMiterSkeletonIndexRoute
  "/showroom/plan/$home_plan_id/": typeof ShowroomPlanHome_plan_idIndexRoute
  "/builders/$builder_id/communities/$community_id/$": typeof BuildersBuilder_idCommunitiesCommunity_idSplatRoute
  "/builders/$builder_id/communities/$community_id/plans": typeof BuildersBuilder_idCommunitiesCommunity_idPlansRoute
  "/builders/$builder_id/estimate/integrations/costcodes": typeof BuildersBuilder_idEstimateIntegrationsCostcodesRoute
  "/builders/$builder_id/estimate/integrations/customfields": typeof BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute
  "/builders/$builder_id/estimate/integrations/resources": typeof BuildersBuilder_idEstimateIntegrationsResourcesRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewRoute
  "/builders/$builder_id/home-plans/$home_plan_id/overview-internal": typeof BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute
  "/builders/$builder_id/home-plans/$home_plan_id/sales-view": typeof BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/edit": typeof BuildersBuilder_idLocationsLocation_idEditRoute
  "/builders/$builder_id/locations/$location_id/home-plans": typeof BuildersBuilder_idLocationsLocation_idHomePlansRoute
  "/builders/$builder_id/master-plans/$master_plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute
  "/builders/$builder_id/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/options/edit/options": typeof BuildersBuilder_idOptionsEditOptionsRoute
  "/builders/$builder_id/options/edit/set": typeof BuildersBuilder_idOptionsEditSetRoute
  "/builders/$builder_id/options/edit/sets": typeof BuildersBuilder_idOptionsEditSetsRoute
  "/builders/$builder_id/auto-renders/$item_id/": typeof BuildersBuilder_idAutoRendersItem_idIndexRoute
  "/builders/$builder_id/estimate/integrations/": typeof BuildersBuilder_idEstimateIntegrationsIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id/": typeof BuildersBuilder_idHomePlansHome_plan_idIndexRoute
  "/builders/$builder_id/master-plans/$master_plan_id/": typeof BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute
  "/builders/$builder_id/tasks/$task_id/": typeof BuildersBuilder_idTasksTask_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute
  "/builders/$builder_id/home-plans/$home_plan_id/ops-view/": typeof BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute
  "/builders/$builder_id/home-plans/$home_plan_id/showroom/": typeof BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute
  "/builders/$builder_id/locations/$location_id/lots/": typeof BuildersBuilder_idLocationsLocation_idLotsIndexRoute
  "/builders/$builder_id/locations/$location_id/map/": typeof BuildersBuilder_idLocationsLocation_idMapIndexRoute
  "/builders/$builder_id/locations/$location_id/options/": typeof BuildersBuilder_idLocationsLocation_idOptionsIndexRoute
  "/builders/$builder_id/locations/$location_id/sales-map/": typeof BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute
  "/builders/$builder_id/locations/$location_id/studio-docs/": typeof BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute
  "/builders/$builder_id/locations/$location_id/sub-locations/": typeof BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute
  "/builders/$builder_id/locations/$location_id/tasks/": typeof BuildersBuilder_idLocationsLocation_idTasksIndexRoute
  "/builders/$builder_id/locations/$location_id/workbooks/": typeof BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute
  "/demo/builders/$builder_name/selections/$scene_id/": typeof DemoBuildersBuilder_nameSelectionsScene_idIndexRoute
  "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/": typeof DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/lots/$lot_id/": typeof BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute
  "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/": typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute
  "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$": typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute
  "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/": typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/404"
    | "/error"
    | "/graphics-troubleshooting-test"
    | "/intel-driver-bug-repro-2024"
    | "/platform-diagnostics"
    | "/studio"
    | "/studio-sales-view"
    | "/studio-showroom"
    | "/account/callback"
    | "/account/dashboard"
    | "/account/login"
    | "/account/reset-password"
    | "/account/update-password"
    | "/admin/builders"
    | "/admin/debug"
    | "/admin/features"
    | "/admin/homes"
    | "/admin/plan-analysis"
    | "/admin/selections"
    | "/admin/settings"
    | "/admin/users"
    | "/debug/annotation"
    | "/debug/building-debugger"
    | "/debug/building-gltf"
    | "/debug/building-gltf-lambda"
    | "/debug/building-query"
    | "/debug/building-renderer"
    | "/debug/calibration-texture-test"
    | "/debug/compare-roof-viewer"
    | "/debug/crash-test"
    | "/debug/design-material"
    | "/debug/design-material-docs"
    | "/debug/design-material-editor"
    | "/debug/error-403"
    | "/debug/export"
    | "/debug/exr-test"
    | "/debug/exterior-scene"
    | "/debug/face-diff-viewer"
    | "/debug/hatch-material-generation"
    | "/debug/hatching-test"
    | "/debug/iframe-test"
    | "/debug/image-service"
    | "/debug/material-appearance-test"
    | "/debug/material-cache-manager"
    | "/debug/material-id"
    | "/debug/material-thumbnails"
    | "/debug/option-catalog-repair"
    | "/debug/palette-thumbnail-cache-bust"
    | "/debug/palette-thumbnail-test"
    | "/debug/panorama-viewer"
    | "/debug/pdf-diff"
    | "/debug/plan-render"
    | "/debug/planar-graph"
    | "/debug/prop-aws-admin"
    | "/debug/prop-aws-batch"
    | "/debug/props"
    | "/debug/render"
    | "/debug/repair-home"
    | "/debug/selections"
    | "/debug/server-errors"
    | "/debug/showroom-floorplan"
    | "/debug/showroom-gltf-import-performance"
    | "/debug/showroom-intro-performance"
    | "/debug/source-graph-analyzer"
    | "/debug/ssrr-test"
    | "/debug/stroke-test"
    | "/debug/svg-bb"
    | "/debug/text-test"
    | "/debug/tonemapping-test"
    | "/debug/viewer-state-management"
    | "/debug/walkthrough"
    | "/debug/walkthrough-caching"
    | "/debug/wasm"
    | "/debug/webgl-context-sharing"
    | "/debug/webgl-context-sharing-transform"
    | "/debug/webgl-service"
    | "/demo/ibs-2023-selections"
    | "/demo/ibs-2023-start"
    | "/demo/ibs-2023-walkthrough"
    | "/demo/photoreal-interior360-TS21DMPO80M1"
    | "/demo/photoreal-selections"
    | "/demo/photoreal-selections360-WX34VCTU45P2"
    | "/demo/photoreal-walkthrough"
    | "/demo/sheets"
    | "/demo/showroom"
    | "/invites/$invite_id"
    | "/showroom/intro"
    | "/showroom/studio"
    | "/admin/"
    | "/debug/"
    | "/showroom/"
    | "/builders/$builder_id/estimate"
    | "/builders/$builder_id/options"
    | "/builders/$builder_id/configure"
    | "/builders/$builder_id/files"
    | "/builders/$builder_id/guided-flow"
    | "/builders/$builder_id/plans"
    | "/debug/builder-website/sales-map"
    | "/debug/builder-website/showroom-intro"
    | "/debug/framing/truss2D"
    | "/debug/geom/straight-skeleton-offset"
    | "/debug/geom/straight-skeleton-offset-single"
    | "/debug/gfx-stress/geometry-stress-incremental"
    | "/debug/gfx-stress/material-stress"
    | "/debug/gfx-stress/material-stress-incremental"
    | "/debug/gfx-test/material-render"
    | "/debug/gfx-test/threeviewer-init"
    | "/debug/option-migration/migrate-options"
    | "/debug/polyclip/brep-set-ops-test"
    | "/debug/polyclip/brep-trim-test"
    | "/debug/polyclip/offset-closed-test"
    | "/debug/polyclip/plane-trim-test"
    | "/debug/polyclip/set-ops-bench"
    | "/debug/polyclip/set-ops-fuzz"
    | "/debug/polyclip/set-ops-test"
    | "/debug/polyclip/snap-round-test"
    | "/debug/polyclip/trim-faces-test"
    | "/debug/schema/bapi-kams"
    | "/debug/schema/building-api"
    | "/demo/connected/bigscreen"
    | "/demo/connected/showroom"
    | "/demo/connected/singlescreen"
    | "/demo/connected/tabs"
    | "/showroom/edit/intro"
    | "/admin/component-library/"
    | "/admin/data-migration/"
    | "/builders/$builder_id/"
    | "/debug/builder-website/"
    | "/debug/floor-framing/"
    | "/debug/geom/"
    | "/debug/option-migration/"
    | "/debug/wall-framing/"
    | "/demo/connected/"
    | "/builders/$builder_id/locations/new"
    | "/builders/$builder_id/procure/$"
    | "/debug/geom/miter-skeleton/skeleton"
    | "/showroom/plan/$home_plan_id/ops"
    | "/showroom/plan/$home_plan_id/overview"
    | "/builders/$builder_id/account/"
    | "/builders/$builder_id/auto-renders/"
    | "/builders/$builder_id/communities/"
    | "/builders/$builder_id/developers/"
    | "/builders/$builder_id/estimate/"
    | "/builders/$builder_id/integrations/"
    | "/builders/$builder_id/locations/"
    | "/builders/$builder_id/marketing/"
    | "/builders/$builder_id/master-plans/"
    | "/builders/$builder_id/options/"
    | "/builders/$builder_id/tasks/"
    | "/builders/$builder_id/users/"
    | "/debug/geom/miter-skeleton/"
    | "/showroom/plan/$home_plan_id/"
    | "/builders/$builder_id/communities/$community_id/$"
    | "/builders/$builder_id/communities/$community_id/plans"
    | "/builders/$builder_id/estimate/integrations/costcodes"
    | "/builders/$builder_id/estimate/integrations/customfields"
    | "/builders/$builder_id/estimate/integrations/resources"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
    | "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/edit"
    | "/builders/$builder_id/locations/$location_id/home-plans"
    | "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
    | "/builders/$builder_id/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/options/edit/options"
    | "/builders/$builder_id/options/edit/set"
    | "/builders/$builder_id/options/edit/sets"
    | "/builders/$builder_id/auto-renders/$item_id/"
    | "/builders/$builder_id/estimate/integrations/"
    | "/builders/$builder_id/home-plans/$home_plan_id/"
    | "/builders/$builder_id/master-plans/$master_plan_id/"
    | "/builders/$builder_id/tasks/$task_id/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/home-plans/$home_plan_id/ops-view/"
    | "/builders/$builder_id/home-plans/$home_plan_id/showroom/"
    | "/builders/$builder_id/locations/$location_id/location-plans/"
    | "/builders/$builder_id/locations/$location_id/lots/"
    | "/builders/$builder_id/locations/$location_id/map/"
    | "/builders/$builder_id/locations/$location_id/options/"
    | "/builders/$builder_id/locations/$location_id/sales-map/"
    | "/builders/$builder_id/locations/$location_id/studio-docs/"
    | "/builders/$builder_id/locations/$location_id/sub-locations/"
    | "/builders/$builder_id/locations/$location_id/tasks/"
    | "/builders/$builder_id/locations/$location_id/workbooks/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/"
    | "/demo/builders/$builder_name/selections/$scene_id/"
    | "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/"
    | "/builders/$builder_id/locations/$location_id/lots/$lot_id/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/404"
    | "/error"
    | "/graphics-troubleshooting-test"
    | "/intel-driver-bug-repro-2024"
    | "/platform-diagnostics"
    | "/studio"
    | "/studio-sales-view"
    | "/studio-showroom"
    | "/account/callback"
    | "/account/dashboard"
    | "/account/login"
    | "/account/reset-password"
    | "/account/update-password"
    | "/admin/builders"
    | "/admin/debug"
    | "/admin/features"
    | "/admin/homes"
    | "/admin/plan-analysis"
    | "/admin/selections"
    | "/admin/settings"
    | "/admin/users"
    | "/debug/annotation"
    | "/debug/building-debugger"
    | "/debug/building-gltf"
    | "/debug/building-gltf-lambda"
    | "/debug/building-query"
    | "/debug/building-renderer"
    | "/debug/calibration-texture-test"
    | "/debug/compare-roof-viewer"
    | "/debug/crash-test"
    | "/debug/design-material"
    | "/debug/design-material-docs"
    | "/debug/design-material-editor"
    | "/debug/error-403"
    | "/debug/export"
    | "/debug/exr-test"
    | "/debug/exterior-scene"
    | "/debug/face-diff-viewer"
    | "/debug/hatch-material-generation"
    | "/debug/hatching-test"
    | "/debug/iframe-test"
    | "/debug/image-service"
    | "/debug/material-appearance-test"
    | "/debug/material-cache-manager"
    | "/debug/material-id"
    | "/debug/material-thumbnails"
    | "/debug/option-catalog-repair"
    | "/debug/palette-thumbnail-cache-bust"
    | "/debug/palette-thumbnail-test"
    | "/debug/panorama-viewer"
    | "/debug/pdf-diff"
    | "/debug/plan-render"
    | "/debug/planar-graph"
    | "/debug/prop-aws-admin"
    | "/debug/prop-aws-batch"
    | "/debug/props"
    | "/debug/render"
    | "/debug/repair-home"
    | "/debug/selections"
    | "/debug/server-errors"
    | "/debug/showroom-floorplan"
    | "/debug/showroom-gltf-import-performance"
    | "/debug/showroom-intro-performance"
    | "/debug/source-graph-analyzer"
    | "/debug/ssrr-test"
    | "/debug/stroke-test"
    | "/debug/svg-bb"
    | "/debug/text-test"
    | "/debug/tonemapping-test"
    | "/debug/viewer-state-management"
    | "/debug/walkthrough"
    | "/debug/walkthrough-caching"
    | "/debug/wasm"
    | "/debug/webgl-context-sharing"
    | "/debug/webgl-context-sharing-transform"
    | "/debug/webgl-service"
    | "/demo/ibs-2023-selections"
    | "/demo/ibs-2023-start"
    | "/demo/ibs-2023-walkthrough"
    | "/demo/photoreal-interior360-TS21DMPO80M1"
    | "/demo/photoreal-selections"
    | "/demo/photoreal-selections360-WX34VCTU45P2"
    | "/demo/photoreal-walkthrough"
    | "/demo/sheets"
    | "/demo/showroom"
    | "/invites/$invite_id"
    | "/showroom/intro"
    | "/showroom/studio"
    | "/admin"
    | "/debug"
    | "/showroom"
    | "/builders/$builder_id/configure"
    | "/builders/$builder_id/files"
    | "/builders/$builder_id/guided-flow"
    | "/builders/$builder_id/plans"
    | "/debug/builder-website/sales-map"
    | "/debug/builder-website/showroom-intro"
    | "/debug/framing/truss2D"
    | "/debug/geom/straight-skeleton-offset"
    | "/debug/geom/straight-skeleton-offset-single"
    | "/debug/gfx-stress/geometry-stress-incremental"
    | "/debug/gfx-stress/material-stress"
    | "/debug/gfx-stress/material-stress-incremental"
    | "/debug/gfx-test/material-render"
    | "/debug/gfx-test/threeviewer-init"
    | "/debug/option-migration/migrate-options"
    | "/debug/polyclip/brep-set-ops-test"
    | "/debug/polyclip/brep-trim-test"
    | "/debug/polyclip/offset-closed-test"
    | "/debug/polyclip/plane-trim-test"
    | "/debug/polyclip/set-ops-bench"
    | "/debug/polyclip/set-ops-fuzz"
    | "/debug/polyclip/set-ops-test"
    | "/debug/polyclip/snap-round-test"
    | "/debug/polyclip/trim-faces-test"
    | "/debug/schema/bapi-kams"
    | "/debug/schema/building-api"
    | "/demo/connected/bigscreen"
    | "/demo/connected/showroom"
    | "/demo/connected/singlescreen"
    | "/demo/connected/tabs"
    | "/showroom/edit/intro"
    | "/admin/component-library"
    | "/admin/data-migration"
    | "/builders/$builder_id"
    | "/debug/builder-website"
    | "/debug/floor-framing"
    | "/debug/geom"
    | "/debug/option-migration"
    | "/debug/wall-framing"
    | "/demo/connected"
    | "/builders/$builder_id/locations/new"
    | "/builders/$builder_id/procure/$"
    | "/debug/geom/miter-skeleton/skeleton"
    | "/showroom/plan/$home_plan_id/ops"
    | "/showroom/plan/$home_plan_id/overview"
    | "/builders/$builder_id/account"
    | "/builders/$builder_id/auto-renders"
    | "/builders/$builder_id/communities"
    | "/builders/$builder_id/developers"
    | "/builders/$builder_id/estimate"
    | "/builders/$builder_id/integrations"
    | "/builders/$builder_id/locations"
    | "/builders/$builder_id/marketing"
    | "/builders/$builder_id/master-plans"
    | "/builders/$builder_id/options"
    | "/builders/$builder_id/tasks"
    | "/builders/$builder_id/users"
    | "/debug/geom/miter-skeleton"
    | "/showroom/plan/$home_plan_id"
    | "/builders/$builder_id/communities/$community_id/$"
    | "/builders/$builder_id/communities/$community_id/plans"
    | "/builders/$builder_id/estimate/integrations/costcodes"
    | "/builders/$builder_id/estimate/integrations/customfields"
    | "/builders/$builder_id/estimate/integrations/resources"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
    | "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/edit"
    | "/builders/$builder_id/locations/$location_id/home-plans"
    | "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
    | "/builders/$builder_id/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/options/edit/options"
    | "/builders/$builder_id/options/edit/set"
    | "/builders/$builder_id/options/edit/sets"
    | "/builders/$builder_id/auto-renders/$item_id"
    | "/builders/$builder_id/estimate/integrations"
    | "/builders/$builder_id/home-plans/$home_plan_id"
    | "/builders/$builder_id/master-plans/$master_plan_id"
    | "/builders/$builder_id/tasks/$task_id"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/home-plans/$home_plan_id/ops-view"
    | "/builders/$builder_id/home-plans/$home_plan_id/showroom"
    | "/builders/$builder_id/locations/$location_id/location-plans"
    | "/builders/$builder_id/locations/$location_id/lots"
    | "/builders/$builder_id/locations/$location_id/map"
    | "/builders/$builder_id/locations/$location_id/options"
    | "/builders/$builder_id/locations/$location_id/sales-map"
    | "/builders/$builder_id/locations/$location_id/studio-docs"
    | "/builders/$builder_id/locations/$location_id/sub-locations"
    | "/builders/$builder_id/locations/$location_id/tasks"
    | "/builders/$builder_id/locations/$location_id/workbooks"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id"
    | "/demo/builders/$builder_name/selections/$scene_id"
    | "/demo/builders/$builder_name/walkthroughs/$walkthrough_id"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id"
    | "/builders/$builder_id/locations/$location_id/lots/$lot_id"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id"
  id:
    | "__root__"
    | "/"
    | "/404"
    | "/error"
    | "/graphics-troubleshooting-test"
    | "/intel-driver-bug-repro-2024"
    | "/platform-diagnostics"
    | "/studio"
    | "/studio-sales-view"
    | "/studio-showroom"
    | "/account/callback"
    | "/account/dashboard"
    | "/account/login"
    | "/account/reset-password"
    | "/account/update-password"
    | "/admin/builders"
    | "/admin/debug"
    | "/admin/features"
    | "/admin/homes"
    | "/admin/plan-analysis"
    | "/admin/selections"
    | "/admin/settings"
    | "/admin/users"
    | "/debug/annotation"
    | "/debug/building-debugger"
    | "/debug/building-gltf"
    | "/debug/building-gltf-lambda"
    | "/debug/building-query"
    | "/debug/building-renderer"
    | "/debug/calibration-texture-test"
    | "/debug/compare-roof-viewer"
    | "/debug/crash-test"
    | "/debug/design-material"
    | "/debug/design-material-docs"
    | "/debug/design-material-editor"
    | "/debug/error-403"
    | "/debug/export"
    | "/debug/exr-test"
    | "/debug/exterior-scene"
    | "/debug/face-diff-viewer"
    | "/debug/hatch-material-generation"
    | "/debug/hatching-test"
    | "/debug/iframe-test"
    | "/debug/image-service"
    | "/debug/material-appearance-test"
    | "/debug/material-cache-manager"
    | "/debug/material-id"
    | "/debug/material-thumbnails"
    | "/debug/option-catalog-repair"
    | "/debug/palette-thumbnail-cache-bust"
    | "/debug/palette-thumbnail-test"
    | "/debug/panorama-viewer"
    | "/debug/pdf-diff"
    | "/debug/plan-render"
    | "/debug/planar-graph"
    | "/debug/prop-aws-admin"
    | "/debug/prop-aws-batch"
    | "/debug/props"
    | "/debug/render"
    | "/debug/repair-home"
    | "/debug/selections"
    | "/debug/server-errors"
    | "/debug/showroom-floorplan"
    | "/debug/showroom-gltf-import-performance"
    | "/debug/showroom-intro-performance"
    | "/debug/source-graph-analyzer"
    | "/debug/ssrr-test"
    | "/debug/stroke-test"
    | "/debug/svg-bb"
    | "/debug/text-test"
    | "/debug/tonemapping-test"
    | "/debug/viewer-state-management"
    | "/debug/walkthrough"
    | "/debug/walkthrough-caching"
    | "/debug/wasm"
    | "/debug/webgl-context-sharing"
    | "/debug/webgl-context-sharing-transform"
    | "/debug/webgl-service"
    | "/demo/ibs-2023-selections"
    | "/demo/ibs-2023-start"
    | "/demo/ibs-2023-walkthrough"
    | "/demo/photoreal-interior360-TS21DMPO80M1"
    | "/demo/photoreal-selections"
    | "/demo/photoreal-selections360-WX34VCTU45P2"
    | "/demo/photoreal-walkthrough"
    | "/demo/sheets"
    | "/demo/showroom"
    | "/invites/$invite_id"
    | "/showroom/intro"
    | "/showroom/studio"
    | "/admin/"
    | "/debug/"
    | "/showroom/"
    | "/builders/$builder_id/estimate"
    | "/builders/$builder_id/options"
    | "/builders/$builder_id/configure"
    | "/builders/$builder_id/files"
    | "/builders/$builder_id/guided-flow"
    | "/builders/$builder_id/plans"
    | "/debug/builder-website/sales-map"
    | "/debug/builder-website/showroom-intro"
    | "/debug/framing/truss2D"
    | "/debug/geom/straight-skeleton-offset"
    | "/debug/geom/straight-skeleton-offset-single"
    | "/debug/gfx-stress/geometry-stress-incremental"
    | "/debug/gfx-stress/material-stress"
    | "/debug/gfx-stress/material-stress-incremental"
    | "/debug/gfx-test/material-render"
    | "/debug/gfx-test/threeviewer-init"
    | "/debug/option-migration/migrate-options"
    | "/debug/polyclip/brep-set-ops-test"
    | "/debug/polyclip/brep-trim-test"
    | "/debug/polyclip/offset-closed-test"
    | "/debug/polyclip/plane-trim-test"
    | "/debug/polyclip/set-ops-bench"
    | "/debug/polyclip/set-ops-fuzz"
    | "/debug/polyclip/set-ops-test"
    | "/debug/polyclip/snap-round-test"
    | "/debug/polyclip/trim-faces-test"
    | "/debug/schema/bapi-kams"
    | "/debug/schema/building-api"
    | "/demo/connected/bigscreen"
    | "/demo/connected/showroom"
    | "/demo/connected/singlescreen"
    | "/demo/connected/tabs"
    | "/showroom/edit/intro"
    | "/admin/component-library/"
    | "/admin/data-migration/"
    | "/builders/$builder_id/"
    | "/debug/builder-website/"
    | "/debug/floor-framing/"
    | "/debug/geom/"
    | "/debug/option-migration/"
    | "/debug/wall-framing/"
    | "/demo/connected/"
    | "/builders/$builder_id/locations/new"
    | "/builders/$builder_id/procure/$"
    | "/debug/geom/miter-skeleton/skeleton"
    | "/showroom/plan/$home_plan_id/ops"
    | "/showroom/plan/$home_plan_id/overview"
    | "/builders/$builder_id/account/"
    | "/builders/$builder_id/auto-renders/"
    | "/builders/$builder_id/communities/"
    | "/builders/$builder_id/developers/"
    | "/builders/$builder_id/estimate/"
    | "/builders/$builder_id/integrations/"
    | "/builders/$builder_id/locations/"
    | "/builders/$builder_id/marketing/"
    | "/builders/$builder_id/master-plans/"
    | "/builders/$builder_id/options/"
    | "/builders/$builder_id/tasks/"
    | "/builders/$builder_id/users/"
    | "/debug/geom/miter-skeleton/"
    | "/showroom/plan/$home_plan_id/"
    | "/builders/$builder_id/communities/$community_id/$"
    | "/builders/$builder_id/communities/$community_id/plans"
    | "/builders/$builder_id/estimate/integrations/costcodes"
    | "/builders/$builder_id/estimate/integrations/customfields"
    | "/builders/$builder_id/estimate/integrations/resources"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview"
    | "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
    | "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/edit"
    | "/builders/$builder_id/locations/$location_id/home-plans"
    | "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
    | "/builders/$builder_id/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/options/edit/options"
    | "/builders/$builder_id/options/edit/set"
    | "/builders/$builder_id/options/edit/sets"
    | "/builders/$builder_id/auto-renders/$item_id/"
    | "/builders/$builder_id/estimate/integrations/"
    | "/builders/$builder_id/home-plans/$home_plan_id/"
    | "/builders/$builder_id/master-plans/$master_plan_id/"
    | "/builders/$builder_id/tasks/$task_id/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
    | "/builders/$builder_id/home-plans/$home_plan_id/ops-view/"
    | "/builders/$builder_id/home-plans/$home_plan_id/showroom/"
    | "/builders/$builder_id/locations/$location_id/location-plans/"
    | "/builders/$builder_id/locations/$location_id/lots/"
    | "/builders/$builder_id/locations/$location_id/map/"
    | "/builders/$builder_id/locations/$location_id/options/"
    | "/builders/$builder_id/locations/$location_id/sales-map/"
    | "/builders/$builder_id/locations/$location_id/studio-docs/"
    | "/builders/$builder_id/locations/$location_id/sub-locations/"
    | "/builders/$builder_id/locations/$location_id/tasks/"
    | "/builders/$builder_id/locations/$location_id/workbooks/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/"
    | "/demo/builders/$builder_name/selections/$scene_id/"
    | "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/"
    | "/builders/$builder_id/locations/$location_id/lots/$lot_id/"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
    | "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
    | "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
    | "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ErrorRoute: typeof ErrorRoute
  GraphicsTroubleshootingTestRoute: typeof GraphicsTroubleshootingTestRoute
  IntelDriverBugRepro2024Route: typeof IntelDriverBugRepro2024Route
  PlatformDiagnosticsRoute: typeof PlatformDiagnosticsRoute
  StudioRoute: typeof StudioRoute
  StudioSalesViewRoute: typeof StudioSalesViewRoute
  StudioShowroomRoute: typeof StudioShowroomRoute
  AccountCallbackRoute: typeof AccountCallbackRoute
  AccountDashboardRoute: typeof AccountDashboardRoute
  AccountLoginRoute: typeof AccountLoginRoute
  AccountResetPasswordRoute: typeof AccountResetPasswordRoute
  AccountUpdatePasswordRoute: typeof AccountUpdatePasswordRoute
  AdminBuildersRoute: typeof AdminBuildersRoute
  AdminDebugRoute: typeof AdminDebugRoute
  AdminFeaturesRoute: typeof AdminFeaturesRoute
  AdminHomesRoute: typeof AdminHomesRoute
  AdminPlanAnalysisRoute: typeof AdminPlanAnalysisRoute
  AdminSelectionsRoute: typeof AdminSelectionsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  DebugAnnotationRoute: typeof DebugAnnotationRoute
  DebugBuildingDebuggerRoute: typeof DebugBuildingDebuggerRoute
  DebugBuildingGltfRoute: typeof DebugBuildingGltfRoute
  DebugBuildingGltfLambdaRoute: typeof DebugBuildingGltfLambdaRoute
  DebugBuildingQueryRoute: typeof DebugBuildingQueryRoute
  DebugBuildingRendererRoute: typeof DebugBuildingRendererRoute
  DebugCalibrationTextureTestRoute: typeof DebugCalibrationTextureTestRoute
  DebugCompareRoofViewerRoute: typeof DebugCompareRoofViewerRoute
  DebugCrashTestRoute: typeof DebugCrashTestRoute
  DebugDesignMaterialRoute: typeof DebugDesignMaterialRoute
  DebugDesignMaterialDocsRoute: typeof DebugDesignMaterialDocsRoute
  DebugDesignMaterialEditorRoute: typeof DebugDesignMaterialEditorRoute
  DebugError403Route: typeof DebugError403Route
  DebugExportRoute: typeof DebugExportRoute
  DebugExrTestRoute: typeof DebugExrTestRoute
  DebugExteriorSceneRoute: typeof DebugExteriorSceneRoute
  DebugFaceDiffViewerRoute: typeof DebugFaceDiffViewerRoute
  DebugHatchMaterialGenerationRoute: typeof DebugHatchMaterialGenerationRoute
  DebugHatchingTestRoute: typeof DebugHatchingTestRoute
  DebugIframeTestRoute: typeof DebugIframeTestRoute
  DebugImageServiceRoute: typeof DebugImageServiceRoute
  DebugMaterialAppearanceTestRoute: typeof DebugMaterialAppearanceTestRoute
  DebugMaterialCacheManagerRoute: typeof DebugMaterialCacheManagerRoute
  DebugMaterialIdRoute: typeof DebugMaterialIdRoute
  DebugMaterialThumbnailsRoute: typeof DebugMaterialThumbnailsRoute
  DebugOptionCatalogRepairRoute: typeof DebugOptionCatalogRepairRoute
  DebugPaletteThumbnailCacheBustRoute: typeof DebugPaletteThumbnailCacheBustRoute
  DebugPaletteThumbnailTestRoute: typeof DebugPaletteThumbnailTestRoute
  DebugPanoramaViewerRoute: typeof DebugPanoramaViewerRoute
  DebugPdfDiffRoute: typeof DebugPdfDiffRoute
  DebugPlanRenderRoute: typeof DebugPlanRenderRoute
  DebugPlanarGraphRoute: typeof DebugPlanarGraphRoute
  DebugPropAwsAdminRoute: typeof DebugPropAwsAdminRoute
  DebugPropAwsBatchRoute: typeof DebugPropAwsBatchRoute
  DebugPropsRoute: typeof DebugPropsRoute
  DebugRenderRoute: typeof DebugRenderRoute
  DebugRepairHomeRoute: typeof DebugRepairHomeRoute
  DebugSelectionsRoute: typeof DebugSelectionsRoute
  DebugServerErrorsRoute: typeof DebugServerErrorsRoute
  DebugShowroomFloorplanRoute: typeof DebugShowroomFloorplanRoute
  DebugShowroomGltfImportPerformanceRoute: typeof DebugShowroomGltfImportPerformanceRoute
  DebugShowroomIntroPerformanceRoute: typeof DebugShowroomIntroPerformanceRoute
  DebugSourceGraphAnalyzerRoute: typeof DebugSourceGraphAnalyzerRoute
  DebugSsrrTestRoute: typeof DebugSsrrTestRoute
  DebugStrokeTestRoute: typeof DebugStrokeTestRoute
  DebugSvgBbRoute: typeof DebugSvgBbRoute
  DebugTextTestRoute: typeof DebugTextTestRoute
  DebugTonemappingTestRoute: typeof DebugTonemappingTestRoute
  DebugViewerStateManagementRoute: typeof DebugViewerStateManagementRoute
  DebugWalkthroughRoute: typeof DebugWalkthroughRoute
  DebugWalkthroughCachingRoute: typeof DebugWalkthroughCachingRoute
  DebugWasmRoute: typeof DebugWasmRoute
  DebugWebglContextSharingRoute: typeof DebugWebglContextSharingRoute
  DebugWebglContextSharingTransformRoute: typeof DebugWebglContextSharingTransformRoute
  DebugWebglServiceRoute: typeof DebugWebglServiceRoute
  DemoIbs2023SelectionsRoute: typeof DemoIbs2023SelectionsRoute
  DemoIbs2023StartRoute: typeof DemoIbs2023StartRoute
  DemoIbs2023WalkthroughRoute: typeof DemoIbs2023WalkthroughRoute
  DemoPhotorealInterior360TS21DMPO80M1Route: typeof DemoPhotorealInterior360TS21DMPO80M1Route
  DemoPhotorealSelectionsRoute: typeof DemoPhotorealSelectionsRoute
  DemoPhotorealSelections360WX34VCTU45P2Route: typeof DemoPhotorealSelections360WX34VCTU45P2Route
  DemoPhotorealWalkthroughRoute: typeof DemoPhotorealWalkthroughRoute
  DemoSheetsRoute: typeof DemoSheetsRoute
  DemoShowroomRoute: typeof DemoShowroomRoute
  InvitesInvite_idRoute: typeof InvitesInvite_idRoute
  ShowroomIntroRoute: typeof ShowroomIntroRoute
  ShowroomStudioRoute: typeof ShowroomStudioRoute
  AdminIndexRoute: typeof AdminIndexRoute
  DebugIndexRoute: typeof DebugIndexRoute
  ShowroomIndexRoute: typeof ShowroomIndexRoute
  BuildersBuilder_idEstimateRouteRoute: typeof BuildersBuilder_idEstimateRouteRouteWithChildren
  BuildersBuilder_idOptionsRouteRoute: typeof BuildersBuilder_idOptionsRouteRouteWithChildren
  BuildersBuilder_idConfigureRoute: typeof BuildersBuilder_idConfigureRoute
  BuildersBuilder_idFilesRoute: typeof BuildersBuilder_idFilesRoute
  BuildersBuilder_idGuidedFlowRoute: typeof BuildersBuilder_idGuidedFlowRoute
  BuildersBuilder_idPlansRoute: typeof BuildersBuilder_idPlansRoute
  DebugBuilderWebsiteSalesMapRoute: typeof DebugBuilderWebsiteSalesMapRoute
  DebugBuilderWebsiteShowroomIntroRoute: typeof DebugBuilderWebsiteShowroomIntroRoute
  DebugFramingTruss2DRoute: typeof DebugFramingTruss2DRoute
  DebugGeomStraightSkeletonOffsetRoute: typeof DebugGeomStraightSkeletonOffsetRoute
  DebugGeomStraightSkeletonOffsetSingleRoute: typeof DebugGeomStraightSkeletonOffsetSingleRoute
  DebugGfxStressGeometryStressIncrementalRoute: typeof DebugGfxStressGeometryStressIncrementalRoute
  DebugGfxStressMaterialStressRoute: typeof DebugGfxStressMaterialStressRoute
  DebugGfxStressMaterialStressIncrementalRoute: typeof DebugGfxStressMaterialStressIncrementalRoute
  DebugGfxTestMaterialRenderRoute: typeof DebugGfxTestMaterialRenderRoute
  DebugGfxTestThreeviewerInitRoute: typeof DebugGfxTestThreeviewerInitRoute
  DebugOptionMigrationMigrateOptionsRoute: typeof DebugOptionMigrationMigrateOptionsRoute
  DebugPolyclipBrepSetOpsTestRoute: typeof DebugPolyclipBrepSetOpsTestRoute
  DebugPolyclipBrepTrimTestRoute: typeof DebugPolyclipBrepTrimTestRoute
  DebugPolyclipOffsetClosedTestRoute: typeof DebugPolyclipOffsetClosedTestRoute
  DebugPolyclipPlaneTrimTestRoute: typeof DebugPolyclipPlaneTrimTestRoute
  DebugPolyclipSetOpsBenchRoute: typeof DebugPolyclipSetOpsBenchRoute
  DebugPolyclipSetOpsFuzzRoute: typeof DebugPolyclipSetOpsFuzzRoute
  DebugPolyclipSetOpsTestRoute: typeof DebugPolyclipSetOpsTestRoute
  DebugPolyclipSnapRoundTestRoute: typeof DebugPolyclipSnapRoundTestRoute
  DebugPolyclipTrimFacesTestRoute: typeof DebugPolyclipTrimFacesTestRoute
  DebugSchemaBapiKamsRoute: typeof DebugSchemaBapiKamsRoute
  DebugSchemaBuildingApiRoute: typeof DebugSchemaBuildingApiRoute
  DemoConnectedBigscreenRoute: typeof DemoConnectedBigscreenRoute
  DemoConnectedShowroomRoute: typeof DemoConnectedShowroomRoute
  DemoConnectedSinglescreenRoute: typeof DemoConnectedSinglescreenRoute
  DemoConnectedTabsRoute: typeof DemoConnectedTabsRoute
  ShowroomEditIntroRoute: typeof ShowroomEditIntroRoute
  AdminComponentLibraryIndexRoute: typeof AdminComponentLibraryIndexRoute
  AdminDataMigrationIndexRoute: typeof AdminDataMigrationIndexRoute
  BuildersBuilder_idIndexRoute: typeof BuildersBuilder_idIndexRoute
  DebugBuilderWebsiteIndexRoute: typeof DebugBuilderWebsiteIndexRoute
  DebugFloorFramingIndexRoute: typeof DebugFloorFramingIndexRoute
  DebugGeomIndexRoute: typeof DebugGeomIndexRoute
  DebugOptionMigrationIndexRoute: typeof DebugOptionMigrationIndexRoute
  DebugWallFramingIndexRoute: typeof DebugWallFramingIndexRoute
  DemoConnectedIndexRoute: typeof DemoConnectedIndexRoute
  BuildersBuilder_idLocationsNewRoute: typeof BuildersBuilder_idLocationsNewRoute
  BuildersBuilder_idProcureSplatRoute: typeof BuildersBuilder_idProcureSplatRoute
  DebugGeomMiterSkeletonSkeletonRoute: typeof DebugGeomMiterSkeletonSkeletonRoute
  ShowroomPlanHome_plan_idOpsRoute: typeof ShowroomPlanHome_plan_idOpsRoute
  ShowroomPlanHome_plan_idOverviewRoute: typeof ShowroomPlanHome_plan_idOverviewRoute
  BuildersBuilder_idAccountIndexRoute: typeof BuildersBuilder_idAccountIndexRoute
  BuildersBuilder_idAutoRendersIndexRoute: typeof BuildersBuilder_idAutoRendersIndexRoute
  BuildersBuilder_idCommunitiesIndexRoute: typeof BuildersBuilder_idCommunitiesIndexRoute
  BuildersBuilder_idDevelopersIndexRoute: typeof BuildersBuilder_idDevelopersIndexRoute
  BuildersBuilder_idIntegrationsIndexRoute: typeof BuildersBuilder_idIntegrationsIndexRoute
  BuildersBuilder_idLocationsIndexRoute: typeof BuildersBuilder_idLocationsIndexRoute
  BuildersBuilder_idMarketingIndexRoute: typeof BuildersBuilder_idMarketingIndexRoute
  BuildersBuilder_idMasterPlansIndexRoute: typeof BuildersBuilder_idMasterPlansIndexRoute
  BuildersBuilder_idTasksIndexRoute: typeof BuildersBuilder_idTasksIndexRoute
  BuildersBuilder_idUsersIndexRoute: typeof BuildersBuilder_idUsersIndexRoute
  DebugGeomMiterSkeletonIndexRoute: typeof DebugGeomMiterSkeletonIndexRoute
  ShowroomPlanHome_plan_idIndexRoute: typeof ShowroomPlanHome_plan_idIndexRoute
  BuildersBuilder_idCommunitiesCommunity_idSplatRoute: typeof BuildersBuilder_idCommunitiesCommunity_idSplatRoute
  BuildersBuilder_idCommunitiesCommunity_idPlansRoute: typeof BuildersBuilder_idCommunitiesCommunity_idPlansRoute
  BuildersBuilder_idHomePlansHome_plan_idOverviewRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOverviewRoute
  BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute
  BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute: typeof BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute
  BuildersBuilder_idLocationsLocation_idEditRoute: typeof BuildersBuilder_idLocationsLocation_idEditRoute
  BuildersBuilder_idLocationsLocation_idHomePlansRoute: typeof BuildersBuilder_idLocationsLocation_idHomePlansRoute
  BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute
  BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute
  BuildersBuilder_idAutoRendersItem_idIndexRoute: typeof BuildersBuilder_idAutoRendersItem_idIndexRoute
  BuildersBuilder_idHomePlansHome_plan_idIndexRoute: typeof BuildersBuilder_idHomePlansHome_plan_idIndexRoute
  BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute
  BuildersBuilder_idTasksTask_idIndexRoute: typeof BuildersBuilder_idTasksTask_idIndexRoute
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute
  BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute
  BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute: typeof BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute
  BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute
  BuildersBuilder_idLocationsLocation_idLotsIndexRoute: typeof BuildersBuilder_idLocationsLocation_idLotsIndexRoute
  BuildersBuilder_idLocationsLocation_idMapIndexRoute: typeof BuildersBuilder_idLocationsLocation_idMapIndexRoute
  BuildersBuilder_idLocationsLocation_idOptionsIndexRoute: typeof BuildersBuilder_idLocationsLocation_idOptionsIndexRoute
  BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute: typeof BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute
  BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute: typeof BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute
  BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute: typeof BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute
  BuildersBuilder_idLocationsLocation_idTasksIndexRoute: typeof BuildersBuilder_idLocationsLocation_idTasksIndexRoute
  BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute: typeof BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute
  DemoBuildersBuilder_nameSelectionsScene_idIndexRoute: typeof DemoBuildersBuilder_nameSelectionsScene_idIndexRoute
  DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute: typeof DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute
  BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute
  BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute: typeof BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute
  BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/studio-showroom": {
      id: "/studio-showroom"
      path: "/studio-showroom"
      fullPath: "/studio-showroom"
      preLoaderRoute: typeof StudioShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/studio-sales-view": {
      id: "/studio-sales-view"
      path: "/studio-sales-view"
      fullPath: "/studio-sales-view"
      preLoaderRoute: typeof StudioSalesViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/studio": {
      id: "/studio"
      path: "/studio"
      fullPath: "/studio"
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/platform-diagnostics": {
      id: "/platform-diagnostics"
      path: "/platform-diagnostics"
      fullPath: "/platform-diagnostics"
      preLoaderRoute: typeof PlatformDiagnosticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/intel-driver-bug-repro-2024": {
      id: "/intel-driver-bug-repro-2024"
      path: "/intel-driver-bug-repro-2024"
      fullPath: "/intel-driver-bug-repro-2024"
      preLoaderRoute: typeof IntelDriverBugRepro2024RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/graphics-troubleshooting-test": {
      id: "/graphics-troubleshooting-test"
      path: "/graphics-troubleshooting-test"
      fullPath: "/graphics-troubleshooting-test"
      preLoaderRoute: typeof GraphicsTroubleshootingTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/error": {
      id: "/error"
      path: "/error"
      fullPath: "/error"
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/404": {
      id: "/404"
      path: "/404"
      fullPath: "/404"
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/": {
      id: "/showroom/"
      path: "/showroom"
      fullPath: "/showroom/"
      preLoaderRoute: typeof ShowroomIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/": {
      id: "/debug/"
      path: "/debug"
      fullPath: "/debug/"
      preLoaderRoute: typeof DebugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/": {
      id: "/admin/"
      path: "/admin"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/studio": {
      id: "/showroom/studio"
      path: "/showroom/studio"
      fullPath: "/showroom/studio"
      preLoaderRoute: typeof ShowroomStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/intro": {
      id: "/showroom/intro"
      path: "/showroom/intro"
      fullPath: "/showroom/intro"
      preLoaderRoute: typeof ShowroomIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invites/$invite_id": {
      id: "/invites/$invite_id"
      path: "/invites/$invite_id"
      fullPath: "/invites/$invite_id"
      preLoaderRoute: typeof InvitesInvite_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/showroom": {
      id: "/demo/showroom"
      path: "/demo/showroom"
      fullPath: "/demo/showroom"
      preLoaderRoute: typeof DemoShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/sheets": {
      id: "/demo/sheets"
      path: "/demo/sheets"
      fullPath: "/demo/sheets"
      preLoaderRoute: typeof DemoSheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/photoreal-walkthrough": {
      id: "/demo/photoreal-walkthrough"
      path: "/demo/photoreal-walkthrough"
      fullPath: "/demo/photoreal-walkthrough"
      preLoaderRoute: typeof DemoPhotorealWalkthroughRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/photoreal-selections360-WX34VCTU45P2": {
      id: "/demo/photoreal-selections360-WX34VCTU45P2"
      path: "/demo/photoreal-selections360-WX34VCTU45P2"
      fullPath: "/demo/photoreal-selections360-WX34VCTU45P2"
      preLoaderRoute: typeof DemoPhotorealSelections360WX34VCTU45P2RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/photoreal-selections": {
      id: "/demo/photoreal-selections"
      path: "/demo/photoreal-selections"
      fullPath: "/demo/photoreal-selections"
      preLoaderRoute: typeof DemoPhotorealSelectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/photoreal-interior360-TS21DMPO80M1": {
      id: "/demo/photoreal-interior360-TS21DMPO80M1"
      path: "/demo/photoreal-interior360-TS21DMPO80M1"
      fullPath: "/demo/photoreal-interior360-TS21DMPO80M1"
      preLoaderRoute: typeof DemoPhotorealInterior360TS21DMPO80M1RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/ibs-2023-walkthrough": {
      id: "/demo/ibs-2023-walkthrough"
      path: "/demo/ibs-2023-walkthrough"
      fullPath: "/demo/ibs-2023-walkthrough"
      preLoaderRoute: typeof DemoIbs2023WalkthroughRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/ibs-2023-start": {
      id: "/demo/ibs-2023-start"
      path: "/demo/ibs-2023-start"
      fullPath: "/demo/ibs-2023-start"
      preLoaderRoute: typeof DemoIbs2023StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/ibs-2023-selections": {
      id: "/demo/ibs-2023-selections"
      path: "/demo/ibs-2023-selections"
      fullPath: "/demo/ibs-2023-selections"
      preLoaderRoute: typeof DemoIbs2023SelectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/webgl-service": {
      id: "/debug/webgl-service"
      path: "/debug/webgl-service"
      fullPath: "/debug/webgl-service"
      preLoaderRoute: typeof DebugWebglServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/webgl-context-sharing-transform": {
      id: "/debug/webgl-context-sharing-transform"
      path: "/debug/webgl-context-sharing-transform"
      fullPath: "/debug/webgl-context-sharing-transform"
      preLoaderRoute: typeof DebugWebglContextSharingTransformRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/webgl-context-sharing": {
      id: "/debug/webgl-context-sharing"
      path: "/debug/webgl-context-sharing"
      fullPath: "/debug/webgl-context-sharing"
      preLoaderRoute: typeof DebugWebglContextSharingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/wasm": {
      id: "/debug/wasm"
      path: "/debug/wasm"
      fullPath: "/debug/wasm"
      preLoaderRoute: typeof DebugWasmRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/walkthrough-caching": {
      id: "/debug/walkthrough-caching"
      path: "/debug/walkthrough-caching"
      fullPath: "/debug/walkthrough-caching"
      preLoaderRoute: typeof DebugWalkthroughCachingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/walkthrough": {
      id: "/debug/walkthrough"
      path: "/debug/walkthrough"
      fullPath: "/debug/walkthrough"
      preLoaderRoute: typeof DebugWalkthroughRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/viewer-state-management": {
      id: "/debug/viewer-state-management"
      path: "/debug/viewer-state-management"
      fullPath: "/debug/viewer-state-management"
      preLoaderRoute: typeof DebugViewerStateManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/tonemapping-test": {
      id: "/debug/tonemapping-test"
      path: "/debug/tonemapping-test"
      fullPath: "/debug/tonemapping-test"
      preLoaderRoute: typeof DebugTonemappingTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/text-test": {
      id: "/debug/text-test"
      path: "/debug/text-test"
      fullPath: "/debug/text-test"
      preLoaderRoute: typeof DebugTextTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/svg-bb": {
      id: "/debug/svg-bb"
      path: "/debug/svg-bb"
      fullPath: "/debug/svg-bb"
      preLoaderRoute: typeof DebugSvgBbRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/stroke-test": {
      id: "/debug/stroke-test"
      path: "/debug/stroke-test"
      fullPath: "/debug/stroke-test"
      preLoaderRoute: typeof DebugStrokeTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/ssrr-test": {
      id: "/debug/ssrr-test"
      path: "/debug/ssrr-test"
      fullPath: "/debug/ssrr-test"
      preLoaderRoute: typeof DebugSsrrTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/source-graph-analyzer": {
      id: "/debug/source-graph-analyzer"
      path: "/debug/source-graph-analyzer"
      fullPath: "/debug/source-graph-analyzer"
      preLoaderRoute: typeof DebugSourceGraphAnalyzerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/showroom-intro-performance": {
      id: "/debug/showroom-intro-performance"
      path: "/debug/showroom-intro-performance"
      fullPath: "/debug/showroom-intro-performance"
      preLoaderRoute: typeof DebugShowroomIntroPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/showroom-gltf-import-performance": {
      id: "/debug/showroom-gltf-import-performance"
      path: "/debug/showroom-gltf-import-performance"
      fullPath: "/debug/showroom-gltf-import-performance"
      preLoaderRoute: typeof DebugShowroomGltfImportPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/showroom-floorplan": {
      id: "/debug/showroom-floorplan"
      path: "/debug/showroom-floorplan"
      fullPath: "/debug/showroom-floorplan"
      preLoaderRoute: typeof DebugShowroomFloorplanRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/server-errors": {
      id: "/debug/server-errors"
      path: "/debug/server-errors"
      fullPath: "/debug/server-errors"
      preLoaderRoute: typeof DebugServerErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/selections": {
      id: "/debug/selections"
      path: "/debug/selections"
      fullPath: "/debug/selections"
      preLoaderRoute: typeof DebugSelectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/repair-home": {
      id: "/debug/repair-home"
      path: "/debug/repair-home"
      fullPath: "/debug/repair-home"
      preLoaderRoute: typeof DebugRepairHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/render": {
      id: "/debug/render"
      path: "/debug/render"
      fullPath: "/debug/render"
      preLoaderRoute: typeof DebugRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/props": {
      id: "/debug/props"
      path: "/debug/props"
      fullPath: "/debug/props"
      preLoaderRoute: typeof DebugPropsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/prop-aws-batch": {
      id: "/debug/prop-aws-batch"
      path: "/debug/prop-aws-batch"
      fullPath: "/debug/prop-aws-batch"
      preLoaderRoute: typeof DebugPropAwsBatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/prop-aws-admin": {
      id: "/debug/prop-aws-admin"
      path: "/debug/prop-aws-admin"
      fullPath: "/debug/prop-aws-admin"
      preLoaderRoute: typeof DebugPropAwsAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/planar-graph": {
      id: "/debug/planar-graph"
      path: "/debug/planar-graph"
      fullPath: "/debug/planar-graph"
      preLoaderRoute: typeof DebugPlanarGraphRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/plan-render": {
      id: "/debug/plan-render"
      path: "/debug/plan-render"
      fullPath: "/debug/plan-render"
      preLoaderRoute: typeof DebugPlanRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/pdf-diff": {
      id: "/debug/pdf-diff"
      path: "/debug/pdf-diff"
      fullPath: "/debug/pdf-diff"
      preLoaderRoute: typeof DebugPdfDiffRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/panorama-viewer": {
      id: "/debug/panorama-viewer"
      path: "/debug/panorama-viewer"
      fullPath: "/debug/panorama-viewer"
      preLoaderRoute: typeof DebugPanoramaViewerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/palette-thumbnail-test": {
      id: "/debug/palette-thumbnail-test"
      path: "/debug/palette-thumbnail-test"
      fullPath: "/debug/palette-thumbnail-test"
      preLoaderRoute: typeof DebugPaletteThumbnailTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/palette-thumbnail-cache-bust": {
      id: "/debug/palette-thumbnail-cache-bust"
      path: "/debug/palette-thumbnail-cache-bust"
      fullPath: "/debug/palette-thumbnail-cache-bust"
      preLoaderRoute: typeof DebugPaletteThumbnailCacheBustRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/option-catalog-repair": {
      id: "/debug/option-catalog-repair"
      path: "/debug/option-catalog-repair"
      fullPath: "/debug/option-catalog-repair"
      preLoaderRoute: typeof DebugOptionCatalogRepairRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/material-thumbnails": {
      id: "/debug/material-thumbnails"
      path: "/debug/material-thumbnails"
      fullPath: "/debug/material-thumbnails"
      preLoaderRoute: typeof DebugMaterialThumbnailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/material-id": {
      id: "/debug/material-id"
      path: "/debug/material-id"
      fullPath: "/debug/material-id"
      preLoaderRoute: typeof DebugMaterialIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/material-cache-manager": {
      id: "/debug/material-cache-manager"
      path: "/debug/material-cache-manager"
      fullPath: "/debug/material-cache-manager"
      preLoaderRoute: typeof DebugMaterialCacheManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/material-appearance-test": {
      id: "/debug/material-appearance-test"
      path: "/debug/material-appearance-test"
      fullPath: "/debug/material-appearance-test"
      preLoaderRoute: typeof DebugMaterialAppearanceTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/image-service": {
      id: "/debug/image-service"
      path: "/debug/image-service"
      fullPath: "/debug/image-service"
      preLoaderRoute: typeof DebugImageServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/iframe-test": {
      id: "/debug/iframe-test"
      path: "/debug/iframe-test"
      fullPath: "/debug/iframe-test"
      preLoaderRoute: typeof DebugIframeTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/hatching-test": {
      id: "/debug/hatching-test"
      path: "/debug/hatching-test"
      fullPath: "/debug/hatching-test"
      preLoaderRoute: typeof DebugHatchingTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/hatch-material-generation": {
      id: "/debug/hatch-material-generation"
      path: "/debug/hatch-material-generation"
      fullPath: "/debug/hatch-material-generation"
      preLoaderRoute: typeof DebugHatchMaterialGenerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/face-diff-viewer": {
      id: "/debug/face-diff-viewer"
      path: "/debug/face-diff-viewer"
      fullPath: "/debug/face-diff-viewer"
      preLoaderRoute: typeof DebugFaceDiffViewerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/exterior-scene": {
      id: "/debug/exterior-scene"
      path: "/debug/exterior-scene"
      fullPath: "/debug/exterior-scene"
      preLoaderRoute: typeof DebugExteriorSceneRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/exr-test": {
      id: "/debug/exr-test"
      path: "/debug/exr-test"
      fullPath: "/debug/exr-test"
      preLoaderRoute: typeof DebugExrTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/export": {
      id: "/debug/export"
      path: "/debug/export"
      fullPath: "/debug/export"
      preLoaderRoute: typeof DebugExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/error-403": {
      id: "/debug/error-403"
      path: "/debug/error-403"
      fullPath: "/debug/error-403"
      preLoaderRoute: typeof DebugError403RouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/design-material-editor": {
      id: "/debug/design-material-editor"
      path: "/debug/design-material-editor"
      fullPath: "/debug/design-material-editor"
      preLoaderRoute: typeof DebugDesignMaterialEditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/design-material-docs": {
      id: "/debug/design-material-docs"
      path: "/debug/design-material-docs"
      fullPath: "/debug/design-material-docs"
      preLoaderRoute: typeof DebugDesignMaterialDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/design-material": {
      id: "/debug/design-material"
      path: "/debug/design-material"
      fullPath: "/debug/design-material"
      preLoaderRoute: typeof DebugDesignMaterialRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/crash-test": {
      id: "/debug/crash-test"
      path: "/debug/crash-test"
      fullPath: "/debug/crash-test"
      preLoaderRoute: typeof DebugCrashTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/compare-roof-viewer": {
      id: "/debug/compare-roof-viewer"
      path: "/debug/compare-roof-viewer"
      fullPath: "/debug/compare-roof-viewer"
      preLoaderRoute: typeof DebugCompareRoofViewerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/calibration-texture-test": {
      id: "/debug/calibration-texture-test"
      path: "/debug/calibration-texture-test"
      fullPath: "/debug/calibration-texture-test"
      preLoaderRoute: typeof DebugCalibrationTextureTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/building-renderer": {
      id: "/debug/building-renderer"
      path: "/debug/building-renderer"
      fullPath: "/debug/building-renderer"
      preLoaderRoute: typeof DebugBuildingRendererRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/building-query": {
      id: "/debug/building-query"
      path: "/debug/building-query"
      fullPath: "/debug/building-query"
      preLoaderRoute: typeof DebugBuildingQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/building-gltf-lambda": {
      id: "/debug/building-gltf-lambda"
      path: "/debug/building-gltf-lambda"
      fullPath: "/debug/building-gltf-lambda"
      preLoaderRoute: typeof DebugBuildingGltfLambdaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/building-gltf": {
      id: "/debug/building-gltf"
      path: "/debug/building-gltf"
      fullPath: "/debug/building-gltf"
      preLoaderRoute: typeof DebugBuildingGltfRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/building-debugger": {
      id: "/debug/building-debugger"
      path: "/debug/building-debugger"
      fullPath: "/debug/building-debugger"
      preLoaderRoute: typeof DebugBuildingDebuggerRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/annotation": {
      id: "/debug/annotation"
      path: "/debug/annotation"
      fullPath: "/debug/annotation"
      preLoaderRoute: typeof DebugAnnotationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/users": {
      id: "/admin/users"
      path: "/admin/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/settings": {
      id: "/admin/settings"
      path: "/admin/settings"
      fullPath: "/admin/settings"
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/selections": {
      id: "/admin/selections"
      path: "/admin/selections"
      fullPath: "/admin/selections"
      preLoaderRoute: typeof AdminSelectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/plan-analysis": {
      id: "/admin/plan-analysis"
      path: "/admin/plan-analysis"
      fullPath: "/admin/plan-analysis"
      preLoaderRoute: typeof AdminPlanAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/homes": {
      id: "/admin/homes"
      path: "/admin/homes"
      fullPath: "/admin/homes"
      preLoaderRoute: typeof AdminHomesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/features": {
      id: "/admin/features"
      path: "/admin/features"
      fullPath: "/admin/features"
      preLoaderRoute: typeof AdminFeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/debug": {
      id: "/admin/debug"
      path: "/admin/debug"
      fullPath: "/admin/debug"
      preLoaderRoute: typeof AdminDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/builders": {
      id: "/admin/builders"
      path: "/admin/builders"
      fullPath: "/admin/builders"
      preLoaderRoute: typeof AdminBuildersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/update-password": {
      id: "/account/update-password"
      path: "/account/update-password"
      fullPath: "/account/update-password"
      preLoaderRoute: typeof AccountUpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/reset-password": {
      id: "/account/reset-password"
      path: "/account/reset-password"
      fullPath: "/account/reset-password"
      preLoaderRoute: typeof AccountResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/login": {
      id: "/account/login"
      path: "/account/login"
      fullPath: "/account/login"
      preLoaderRoute: typeof AccountLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/dashboard": {
      id: "/account/dashboard"
      path: "/account/dashboard"
      fullPath: "/account/dashboard"
      preLoaderRoute: typeof AccountDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/callback": {
      id: "/account/callback"
      path: "/account/callback"
      fullPath: "/account/callback"
      preLoaderRoute: typeof AccountCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/connected/": {
      id: "/demo/connected/"
      path: "/demo/connected"
      fullPath: "/demo/connected/"
      preLoaderRoute: typeof DemoConnectedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/wall-framing/": {
      id: "/debug/wall-framing/"
      path: "/debug/wall-framing"
      fullPath: "/debug/wall-framing/"
      preLoaderRoute: typeof DebugWallFramingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/option-migration/": {
      id: "/debug/option-migration/"
      path: "/debug/option-migration"
      fullPath: "/debug/option-migration/"
      preLoaderRoute: typeof DebugOptionMigrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/geom/": {
      id: "/debug/geom/"
      path: "/debug/geom"
      fullPath: "/debug/geom/"
      preLoaderRoute: typeof DebugGeomIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/floor-framing/": {
      id: "/debug/floor-framing/"
      path: "/debug/floor-framing"
      fullPath: "/debug/floor-framing/"
      preLoaderRoute: typeof DebugFloorFramingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/builder-website/": {
      id: "/debug/builder-website/"
      path: "/debug/builder-website"
      fullPath: "/debug/builder-website/"
      preLoaderRoute: typeof DebugBuilderWebsiteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/": {
      id: "/builders/$builder_id/"
      path: "/builders/$builder_id"
      fullPath: "/builders/$builder_id/"
      preLoaderRoute: typeof BuildersBuilder_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/data-migration/": {
      id: "/admin/data-migration/"
      path: "/admin/data-migration"
      fullPath: "/admin/data-migration/"
      preLoaderRoute: typeof AdminDataMigrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/component-library/": {
      id: "/admin/component-library/"
      path: "/admin/component-library"
      fullPath: "/admin/component-library/"
      preLoaderRoute: typeof AdminComponentLibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/edit/intro": {
      id: "/showroom/edit/intro"
      path: "/showroom/edit/intro"
      fullPath: "/showroom/edit/intro"
      preLoaderRoute: typeof ShowroomEditIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/connected/tabs": {
      id: "/demo/connected/tabs"
      path: "/demo/connected/tabs"
      fullPath: "/demo/connected/tabs"
      preLoaderRoute: typeof DemoConnectedTabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/connected/singlescreen": {
      id: "/demo/connected/singlescreen"
      path: "/demo/connected/singlescreen"
      fullPath: "/demo/connected/singlescreen"
      preLoaderRoute: typeof DemoConnectedSinglescreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/connected/showroom": {
      id: "/demo/connected/showroom"
      path: "/demo/connected/showroom"
      fullPath: "/demo/connected/showroom"
      preLoaderRoute: typeof DemoConnectedShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/connected/bigscreen": {
      id: "/demo/connected/bigscreen"
      path: "/demo/connected/bigscreen"
      fullPath: "/demo/connected/bigscreen"
      preLoaderRoute: typeof DemoConnectedBigscreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/schema/building-api": {
      id: "/debug/schema/building-api"
      path: "/debug/schema/building-api"
      fullPath: "/debug/schema/building-api"
      preLoaderRoute: typeof DebugSchemaBuildingApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/schema/bapi-kams": {
      id: "/debug/schema/bapi-kams"
      path: "/debug/schema/bapi-kams"
      fullPath: "/debug/schema/bapi-kams"
      preLoaderRoute: typeof DebugSchemaBapiKamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/trim-faces-test": {
      id: "/debug/polyclip/trim-faces-test"
      path: "/debug/polyclip/trim-faces-test"
      fullPath: "/debug/polyclip/trim-faces-test"
      preLoaderRoute: typeof DebugPolyclipTrimFacesTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/snap-round-test": {
      id: "/debug/polyclip/snap-round-test"
      path: "/debug/polyclip/snap-round-test"
      fullPath: "/debug/polyclip/snap-round-test"
      preLoaderRoute: typeof DebugPolyclipSnapRoundTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/set-ops-test": {
      id: "/debug/polyclip/set-ops-test"
      path: "/debug/polyclip/set-ops-test"
      fullPath: "/debug/polyclip/set-ops-test"
      preLoaderRoute: typeof DebugPolyclipSetOpsTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/set-ops-fuzz": {
      id: "/debug/polyclip/set-ops-fuzz"
      path: "/debug/polyclip/set-ops-fuzz"
      fullPath: "/debug/polyclip/set-ops-fuzz"
      preLoaderRoute: typeof DebugPolyclipSetOpsFuzzRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/set-ops-bench": {
      id: "/debug/polyclip/set-ops-bench"
      path: "/debug/polyclip/set-ops-bench"
      fullPath: "/debug/polyclip/set-ops-bench"
      preLoaderRoute: typeof DebugPolyclipSetOpsBenchRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/plane-trim-test": {
      id: "/debug/polyclip/plane-trim-test"
      path: "/debug/polyclip/plane-trim-test"
      fullPath: "/debug/polyclip/plane-trim-test"
      preLoaderRoute: typeof DebugPolyclipPlaneTrimTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/offset-closed-test": {
      id: "/debug/polyclip/offset-closed-test"
      path: "/debug/polyclip/offset-closed-test"
      fullPath: "/debug/polyclip/offset-closed-test"
      preLoaderRoute: typeof DebugPolyclipOffsetClosedTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/brep-trim-test": {
      id: "/debug/polyclip/brep-trim-test"
      path: "/debug/polyclip/brep-trim-test"
      fullPath: "/debug/polyclip/brep-trim-test"
      preLoaderRoute: typeof DebugPolyclipBrepTrimTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/polyclip/brep-set-ops-test": {
      id: "/debug/polyclip/brep-set-ops-test"
      path: "/debug/polyclip/brep-set-ops-test"
      fullPath: "/debug/polyclip/brep-set-ops-test"
      preLoaderRoute: typeof DebugPolyclipBrepSetOpsTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/option-migration/migrate-options": {
      id: "/debug/option-migration/migrate-options"
      path: "/debug/option-migration/migrate-options"
      fullPath: "/debug/option-migration/migrate-options"
      preLoaderRoute: typeof DebugOptionMigrationMigrateOptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/gfx-test/threeviewer-init": {
      id: "/debug/gfx-test/threeviewer-init"
      path: "/debug/gfx-test/threeviewer-init"
      fullPath: "/debug/gfx-test/threeviewer-init"
      preLoaderRoute: typeof DebugGfxTestThreeviewerInitRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/gfx-test/material-render": {
      id: "/debug/gfx-test/material-render"
      path: "/debug/gfx-test/material-render"
      fullPath: "/debug/gfx-test/material-render"
      preLoaderRoute: typeof DebugGfxTestMaterialRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/gfx-stress/material-stress-incremental": {
      id: "/debug/gfx-stress/material-stress-incremental"
      path: "/debug/gfx-stress/material-stress-incremental"
      fullPath: "/debug/gfx-stress/material-stress-incremental"
      preLoaderRoute: typeof DebugGfxStressMaterialStressIncrementalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/gfx-stress/material-stress": {
      id: "/debug/gfx-stress/material-stress"
      path: "/debug/gfx-stress/material-stress"
      fullPath: "/debug/gfx-stress/material-stress"
      preLoaderRoute: typeof DebugGfxStressMaterialStressRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/gfx-stress/geometry-stress-incremental": {
      id: "/debug/gfx-stress/geometry-stress-incremental"
      path: "/debug/gfx-stress/geometry-stress-incremental"
      fullPath: "/debug/gfx-stress/geometry-stress-incremental"
      preLoaderRoute: typeof DebugGfxStressGeometryStressIncrementalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/geom/straight-skeleton-offset-single": {
      id: "/debug/geom/straight-skeleton-offset-single"
      path: "/debug/geom/straight-skeleton-offset-single"
      fullPath: "/debug/geom/straight-skeleton-offset-single"
      preLoaderRoute: typeof DebugGeomStraightSkeletonOffsetSingleRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/geom/straight-skeleton-offset": {
      id: "/debug/geom/straight-skeleton-offset"
      path: "/debug/geom/straight-skeleton-offset"
      fullPath: "/debug/geom/straight-skeleton-offset"
      preLoaderRoute: typeof DebugGeomStraightSkeletonOffsetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/framing/truss2D": {
      id: "/debug/framing/truss2D"
      path: "/debug/framing/truss2D"
      fullPath: "/debug/framing/truss2D"
      preLoaderRoute: typeof DebugFramingTruss2DRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/builder-website/showroom-intro": {
      id: "/debug/builder-website/showroom-intro"
      path: "/debug/builder-website/showroom-intro"
      fullPath: "/debug/builder-website/showroom-intro"
      preLoaderRoute: typeof DebugBuilderWebsiteShowroomIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/builder-website/sales-map": {
      id: "/debug/builder-website/sales-map"
      path: "/debug/builder-website/sales-map"
      fullPath: "/debug/builder-website/sales-map"
      preLoaderRoute: typeof DebugBuilderWebsiteSalesMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/plans": {
      id: "/builders/$builder_id/plans"
      path: "/builders/$builder_id/plans"
      fullPath: "/builders/$builder_id/plans"
      preLoaderRoute: typeof BuildersBuilder_idPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/guided-flow": {
      id: "/builders/$builder_id/guided-flow"
      path: "/builders/$builder_id/guided-flow"
      fullPath: "/builders/$builder_id/guided-flow"
      preLoaderRoute: typeof BuildersBuilder_idGuidedFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/files": {
      id: "/builders/$builder_id/files"
      path: "/builders/$builder_id/files"
      fullPath: "/builders/$builder_id/files"
      preLoaderRoute: typeof BuildersBuilder_idFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/configure": {
      id: "/builders/$builder_id/configure"
      path: "/builders/$builder_id/configure"
      fullPath: "/builders/$builder_id/configure"
      preLoaderRoute: typeof BuildersBuilder_idConfigureRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/options": {
      id: "/builders/$builder_id/options"
      path: "/builders/$builder_id/options"
      fullPath: "/builders/$builder_id/options"
      preLoaderRoute: typeof BuildersBuilder_idOptionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/estimate": {
      id: "/builders/$builder_id/estimate"
      path: "/builders/$builder_id/estimate"
      fullPath: "/builders/$builder_id/estimate"
      preLoaderRoute: typeof BuildersBuilder_idEstimateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/plan/$home_plan_id/": {
      id: "/showroom/plan/$home_plan_id/"
      path: "/showroom/plan/$home_plan_id"
      fullPath: "/showroom/plan/$home_plan_id/"
      preLoaderRoute: typeof ShowroomPlanHome_plan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/geom/miter-skeleton/": {
      id: "/debug/geom/miter-skeleton/"
      path: "/debug/geom/miter-skeleton"
      fullPath: "/debug/geom/miter-skeleton/"
      preLoaderRoute: typeof DebugGeomMiterSkeletonIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/users/": {
      id: "/builders/$builder_id/users/"
      path: "/builders/$builder_id/users"
      fullPath: "/builders/$builder_id/users/"
      preLoaderRoute: typeof BuildersBuilder_idUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/tasks/": {
      id: "/builders/$builder_id/tasks/"
      path: "/builders/$builder_id/tasks"
      fullPath: "/builders/$builder_id/tasks/"
      preLoaderRoute: typeof BuildersBuilder_idTasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/options/": {
      id: "/builders/$builder_id/options/"
      path: "/"
      fullPath: "/builders/$builder_id/options/"
      preLoaderRoute: typeof BuildersBuilder_idOptionsIndexRouteImport
      parentRoute: typeof BuildersBuilder_idOptionsRouteRoute
    }
    "/builders/$builder_id/master-plans/": {
      id: "/builders/$builder_id/master-plans/"
      path: "/builders/$builder_id/master-plans"
      fullPath: "/builders/$builder_id/master-plans/"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/marketing/": {
      id: "/builders/$builder_id/marketing/"
      path: "/builders/$builder_id/marketing"
      fullPath: "/builders/$builder_id/marketing/"
      preLoaderRoute: typeof BuildersBuilder_idMarketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/": {
      id: "/builders/$builder_id/locations/"
      path: "/builders/$builder_id/locations"
      fullPath: "/builders/$builder_id/locations/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/integrations/": {
      id: "/builders/$builder_id/integrations/"
      path: "/builders/$builder_id/integrations"
      fullPath: "/builders/$builder_id/integrations/"
      preLoaderRoute: typeof BuildersBuilder_idIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/estimate/": {
      id: "/builders/$builder_id/estimate/"
      path: "/"
      fullPath: "/builders/$builder_id/estimate/"
      preLoaderRoute: typeof BuildersBuilder_idEstimateIndexRouteImport
      parentRoute: typeof BuildersBuilder_idEstimateRouteRoute
    }
    "/builders/$builder_id/developers/": {
      id: "/builders/$builder_id/developers/"
      path: "/builders/$builder_id/developers"
      fullPath: "/builders/$builder_id/developers/"
      preLoaderRoute: typeof BuildersBuilder_idDevelopersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/communities/": {
      id: "/builders/$builder_id/communities/"
      path: "/builders/$builder_id/communities"
      fullPath: "/builders/$builder_id/communities/"
      preLoaderRoute: typeof BuildersBuilder_idCommunitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/auto-renders/": {
      id: "/builders/$builder_id/auto-renders/"
      path: "/builders/$builder_id/auto-renders"
      fullPath: "/builders/$builder_id/auto-renders/"
      preLoaderRoute: typeof BuildersBuilder_idAutoRendersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/account/": {
      id: "/builders/$builder_id/account/"
      path: "/builders/$builder_id/account"
      fullPath: "/builders/$builder_id/account/"
      preLoaderRoute: typeof BuildersBuilder_idAccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/plan/$home_plan_id/overview": {
      id: "/showroom/plan/$home_plan_id/overview"
      path: "/showroom/plan/$home_plan_id/overview"
      fullPath: "/showroom/plan/$home_plan_id/overview"
      preLoaderRoute: typeof ShowroomPlanHome_plan_idOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/showroom/plan/$home_plan_id/ops": {
      id: "/showroom/plan/$home_plan_id/ops"
      path: "/showroom/plan/$home_plan_id/ops"
      fullPath: "/showroom/plan/$home_plan_id/ops"
      preLoaderRoute: typeof ShowroomPlanHome_plan_idOpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debug/geom/miter-skeleton/skeleton": {
      id: "/debug/geom/miter-skeleton/skeleton"
      path: "/debug/geom/miter-skeleton/skeleton"
      fullPath: "/debug/geom/miter-skeleton/skeleton"
      preLoaderRoute: typeof DebugGeomMiterSkeletonSkeletonRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/procure/$": {
      id: "/builders/$builder_id/procure/$"
      path: "/builders/$builder_id/procure/$"
      fullPath: "/builders/$builder_id/procure/$"
      preLoaderRoute: typeof BuildersBuilder_idProcureSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/new": {
      id: "/builders/$builder_id/locations/new"
      path: "/builders/$builder_id/locations/new"
      fullPath: "/builders/$builder_id/locations/new"
      preLoaderRoute: typeof BuildersBuilder_idLocationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/tasks/$task_id/": {
      id: "/builders/$builder_id/tasks/$task_id/"
      path: "/builders/$builder_id/tasks/$task_id"
      fullPath: "/builders/$builder_id/tasks/$task_id/"
      preLoaderRoute: typeof BuildersBuilder_idTasksTask_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/master-plans/$master_plan_id/": {
      id: "/builders/$builder_id/master-plans/$master_plan_id/"
      path: "/builders/$builder_id/master-plans/$master_plan_id"
      fullPath: "/builders/$builder_id/master-plans/$master_plan_id/"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/"
      path: "/builders/$builder_id/home-plans/$home_plan_id"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/estimate/integrations/": {
      id: "/builders/$builder_id/estimate/integrations/"
      path: "/integrations"
      fullPath: "/builders/$builder_id/estimate/integrations/"
      preLoaderRoute: typeof BuildersBuilder_idEstimateIntegrationsIndexRouteImport
      parentRoute: typeof BuildersBuilder_idEstimateRouteRoute
    }
    "/builders/$builder_id/auto-renders/$item_id/": {
      id: "/builders/$builder_id/auto-renders/$item_id/"
      path: "/builders/$builder_id/auto-renders/$item_id"
      fullPath: "/builders/$builder_id/auto-renders/$item_id/"
      preLoaderRoute: typeof BuildersBuilder_idAutoRendersItem_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/options/edit/sets": {
      id: "/builders/$builder_id/options/edit/sets"
      path: "/edit/sets"
      fullPath: "/builders/$builder_id/options/edit/sets"
      preLoaderRoute: typeof BuildersBuilder_idOptionsEditSetsRouteImport
      parentRoute: typeof BuildersBuilder_idOptionsRouteRoute
    }
    "/builders/$builder_id/options/edit/set": {
      id: "/builders/$builder_id/options/edit/set"
      path: "/edit/set"
      fullPath: "/builders/$builder_id/options/edit/set"
      preLoaderRoute: typeof BuildersBuilder_idOptionsEditSetRouteImport
      parentRoute: typeof BuildersBuilder_idOptionsRouteRoute
    }
    "/builders/$builder_id/options/edit/options": {
      id: "/builders/$builder_id/options/edit/options"
      path: "/edit/options"
      fullPath: "/builders/$builder_id/options/edit/options"
      preLoaderRoute: typeof BuildersBuilder_idOptionsEditOptionsRouteImport
      parentRoute: typeof BuildersBuilder_idOptionsRouteRoute
    }
    "/builders/$builder_id/master-plans/$master_plan_id/showroom": {
      id: "/builders/$builder_id/master-plans/$master_plan_id/showroom"
      path: "/builders/$builder_id/master-plans/$master_plan_id/showroom"
      fullPath: "/builders/$builder_id/master-plans/$master_plan_id/showroom"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/master-plans/$master_plan_id/sales-view": {
      id: "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
      path: "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
      fullPath: "/builders/$builder_id/master-plans/$master_plan_id/sales-view"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/home-plans": {
      id: "/builders/$builder_id/locations/$location_id/home-plans"
      path: "/builders/$builder_id/locations/$location_id/home-plans"
      fullPath: "/builders/$builder_id/locations/$location_id/home-plans"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idHomePlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/edit": {
      id: "/builders/$builder_id/locations/$location_id/edit"
      path: "/builders/$builder_id/locations/$location_id/edit"
      fullPath: "/builders/$builder_id/locations/$location_id/edit"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/sales-view": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
      path: "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/sales-view"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idSalesViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/overview-internal": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
      path: "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/overview-internal"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/overview": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/overview"
      path: "/builders/$builder_id/home-plans/$home_plan_id/overview"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/overview"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/estimate/integrations/resources": {
      id: "/builders/$builder_id/estimate/integrations/resources"
      path: "/integrations/resources"
      fullPath: "/builders/$builder_id/estimate/integrations/resources"
      preLoaderRoute: typeof BuildersBuilder_idEstimateIntegrationsResourcesRouteImport
      parentRoute: typeof BuildersBuilder_idEstimateRouteRoute
    }
    "/builders/$builder_id/estimate/integrations/customfields": {
      id: "/builders/$builder_id/estimate/integrations/customfields"
      path: "/integrations/customfields"
      fullPath: "/builders/$builder_id/estimate/integrations/customfields"
      preLoaderRoute: typeof BuildersBuilder_idEstimateIntegrationsCustomfieldsRouteImport
      parentRoute: typeof BuildersBuilder_idEstimateRouteRoute
    }
    "/builders/$builder_id/estimate/integrations/costcodes": {
      id: "/builders/$builder_id/estimate/integrations/costcodes"
      path: "/integrations/costcodes"
      fullPath: "/builders/$builder_id/estimate/integrations/costcodes"
      preLoaderRoute: typeof BuildersBuilder_idEstimateIntegrationsCostcodesRouteImport
      parentRoute: typeof BuildersBuilder_idEstimateRouteRoute
    }
    "/builders/$builder_id/communities/$community_id/plans": {
      id: "/builders/$builder_id/communities/$community_id/plans"
      path: "/builders/$builder_id/communities/$community_id/plans"
      fullPath: "/builders/$builder_id/communities/$community_id/plans"
      preLoaderRoute: typeof BuildersBuilder_idCommunitiesCommunity_idPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/communities/$community_id/$": {
      id: "/builders/$builder_id/communities/$community_id/$"
      path: "/builders/$builder_id/communities/$community_id/$"
      fullPath: "/builders/$builder_id/communities/$community_id/$"
      preLoaderRoute: typeof BuildersBuilder_idCommunitiesCommunity_idSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/": {
      id: "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/"
      path: "/demo/builders/$builder_name/walkthroughs/$walkthrough_id"
      fullPath: "/demo/builders/$builder_name/walkthroughs/$walkthrough_id/"
      preLoaderRoute: typeof DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo/builders/$builder_name/selections/$scene_id/": {
      id: "/demo/builders/$builder_name/selections/$scene_id/"
      path: "/demo/builders/$builder_name/selections/$scene_id"
      fullPath: "/demo/builders/$builder_name/selections/$scene_id/"
      preLoaderRoute: typeof DemoBuildersBuilder_nameSelectionsScene_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/marketing/master-plans/$master_plan_id/": {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/"
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id"
      fullPath: "/builders/$builder_id/marketing/master-plans/$master_plan_id/"
      preLoaderRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/workbooks/": {
      id: "/builders/$builder_id/locations/$location_id/workbooks/"
      path: "/builders/$builder_id/locations/$location_id/workbooks"
      fullPath: "/builders/$builder_id/locations/$location_id/workbooks/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idWorkbooksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/tasks/": {
      id: "/builders/$builder_id/locations/$location_id/tasks/"
      path: "/builders/$builder_id/locations/$location_id/tasks"
      fullPath: "/builders/$builder_id/locations/$location_id/tasks/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idTasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/sub-locations/": {
      id: "/builders/$builder_id/locations/$location_id/sub-locations/"
      path: "/builders/$builder_id/locations/$location_id/sub-locations"
      fullPath: "/builders/$builder_id/locations/$location_id/sub-locations/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idSubLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/studio-docs/": {
      id: "/builders/$builder_id/locations/$location_id/studio-docs/"
      path: "/builders/$builder_id/locations/$location_id/studio-docs"
      fullPath: "/builders/$builder_id/locations/$location_id/studio-docs/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idStudioDocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/sales-map/": {
      id: "/builders/$builder_id/locations/$location_id/sales-map/"
      path: "/builders/$builder_id/locations/$location_id/sales-map"
      fullPath: "/builders/$builder_id/locations/$location_id/sales-map/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idSalesMapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/options/": {
      id: "/builders/$builder_id/locations/$location_id/options/"
      path: "/builders/$builder_id/locations/$location_id/options"
      fullPath: "/builders/$builder_id/locations/$location_id/options/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idOptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/map/": {
      id: "/builders/$builder_id/locations/$location_id/map/"
      path: "/builders/$builder_id/locations/$location_id/map"
      fullPath: "/builders/$builder_id/locations/$location_id/map/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idMapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/lots/": {
      id: "/builders/$builder_id/locations/$location_id/lots/"
      path: "/builders/$builder_id/locations/$location_id/lots"
      fullPath: "/builders/$builder_id/locations/$location_id/lots/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLotsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/location-plans/": {
      id: "/builders/$builder_id/locations/$location_id/location-plans/"
      path: "/builders/$builder_id/locations/$location_id/location-plans"
      fullPath: "/builders/$builder_id/locations/$location_id/location-plans/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/showroom/": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/showroom/"
      path: "/builders/$builder_id/home-plans/$home_plan_id/showroom"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/showroom/"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/home-plans/$home_plan_id/ops-view/": {
      id: "/builders/$builder_id/home-plans/$home_plan_id/ops-view/"
      path: "/builders/$builder_id/home-plans/$home_plan_id/ops-view"
      fullPath: "/builders/$builder_id/home-plans/$home_plan_id/ops-view/"
      preLoaderRoute: typeof BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom": {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
      fullPath: "/builders/$builder_id/marketing/master-plans/$master_plan_id/showroom"
      preLoaderRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/lots/$lot_id/": {
      id: "/builders/$builder_id/locations/$location_id/lots/$lot_id/"
      path: "/builders/$builder_id/locations/$location_id/lots/$lot_id"
      fullPath: "/builders/$builder_id/locations/$location_id/lots/$lot_id/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/": {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/"
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id"
      fullPath: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view": {
      id: "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
      path: "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
      fullPath: "/builders/$builder_id/master-plans/$master_plan_id/$community_id/$plan_id/sales-view"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom": {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
      fullPath: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/showroom"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/": {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/"
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id"
      fullPath: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/"
      preLoaderRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom": {
      id: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
      path: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
      fullPath: "/builders/$builder_id/marketing/master-plans/$master_plan_id/$community_id/$plan_id/showroom"
      preLoaderRoute: typeof BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/": {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/"
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id"
      fullPath: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$": {
      id: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
      path: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
      fullPath: "/builders/$builder_id/master-plans/$master_plan_id/communities/$community_id/community-plans/$community_plan_id/$"
      preLoaderRoute: typeof BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom": {
      id: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
      path: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
      fullPath: "/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/lots/$lot_id/showroom"
      preLoaderRoute: typeof BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BuildersBuilder_idEstimateRouteRouteChildren {
  BuildersBuilder_idEstimateIndexRoute: typeof BuildersBuilder_idEstimateIndexRoute
  BuildersBuilder_idEstimateIntegrationsCostcodesRoute: typeof BuildersBuilder_idEstimateIntegrationsCostcodesRoute
  BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute: typeof BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute
  BuildersBuilder_idEstimateIntegrationsResourcesRoute: typeof BuildersBuilder_idEstimateIntegrationsResourcesRoute
  BuildersBuilder_idEstimateIntegrationsIndexRoute: typeof BuildersBuilder_idEstimateIntegrationsIndexRoute
}

const BuildersBuilder_idEstimateRouteRouteChildren: BuildersBuilder_idEstimateRouteRouteChildren =
  {
    BuildersBuilder_idEstimateIndexRoute: BuildersBuilder_idEstimateIndexRoute,
    BuildersBuilder_idEstimateIntegrationsCostcodesRoute:
      BuildersBuilder_idEstimateIntegrationsCostcodesRoute,
    BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute:
      BuildersBuilder_idEstimateIntegrationsCustomfieldsRoute,
    BuildersBuilder_idEstimateIntegrationsResourcesRoute:
      BuildersBuilder_idEstimateIntegrationsResourcesRoute,
    BuildersBuilder_idEstimateIntegrationsIndexRoute:
      BuildersBuilder_idEstimateIntegrationsIndexRoute,
  }

const BuildersBuilder_idEstimateRouteRouteWithChildren =
  BuildersBuilder_idEstimateRouteRoute._addFileChildren(
    BuildersBuilder_idEstimateRouteRouteChildren,
  )

interface BuildersBuilder_idOptionsRouteRouteChildren {
  BuildersBuilder_idOptionsIndexRoute: typeof BuildersBuilder_idOptionsIndexRoute
  BuildersBuilder_idOptionsEditOptionsRoute: typeof BuildersBuilder_idOptionsEditOptionsRoute
  BuildersBuilder_idOptionsEditSetRoute: typeof BuildersBuilder_idOptionsEditSetRoute
  BuildersBuilder_idOptionsEditSetsRoute: typeof BuildersBuilder_idOptionsEditSetsRoute
}

const BuildersBuilder_idOptionsRouteRouteChildren: BuildersBuilder_idOptionsRouteRouteChildren =
  {
    BuildersBuilder_idOptionsIndexRoute: BuildersBuilder_idOptionsIndexRoute,
    BuildersBuilder_idOptionsEditOptionsRoute:
      BuildersBuilder_idOptionsEditOptionsRoute,
    BuildersBuilder_idOptionsEditSetRoute:
      BuildersBuilder_idOptionsEditSetRoute,
    BuildersBuilder_idOptionsEditSetsRoute:
      BuildersBuilder_idOptionsEditSetsRoute,
  }

const BuildersBuilder_idOptionsRouteRouteWithChildren =
  BuildersBuilder_idOptionsRouteRoute._addFileChildren(
    BuildersBuilder_idOptionsRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ErrorRoute: ErrorRoute,
  GraphicsTroubleshootingTestRoute: GraphicsTroubleshootingTestRoute,
  IntelDriverBugRepro2024Route: IntelDriverBugRepro2024Route,
  PlatformDiagnosticsRoute: PlatformDiagnosticsRoute,
  StudioRoute: StudioRoute,
  StudioSalesViewRoute: StudioSalesViewRoute,
  StudioShowroomRoute: StudioShowroomRoute,
  AccountCallbackRoute: AccountCallbackRoute,
  AccountDashboardRoute: AccountDashboardRoute,
  AccountLoginRoute: AccountLoginRoute,
  AccountResetPasswordRoute: AccountResetPasswordRoute,
  AccountUpdatePasswordRoute: AccountUpdatePasswordRoute,
  AdminBuildersRoute: AdminBuildersRoute,
  AdminDebugRoute: AdminDebugRoute,
  AdminFeaturesRoute: AdminFeaturesRoute,
  AdminHomesRoute: AdminHomesRoute,
  AdminPlanAnalysisRoute: AdminPlanAnalysisRoute,
  AdminSelectionsRoute: AdminSelectionsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  DebugAnnotationRoute: DebugAnnotationRoute,
  DebugBuildingDebuggerRoute: DebugBuildingDebuggerRoute,
  DebugBuildingGltfRoute: DebugBuildingGltfRoute,
  DebugBuildingGltfLambdaRoute: DebugBuildingGltfLambdaRoute,
  DebugBuildingQueryRoute: DebugBuildingQueryRoute,
  DebugBuildingRendererRoute: DebugBuildingRendererRoute,
  DebugCalibrationTextureTestRoute: DebugCalibrationTextureTestRoute,
  DebugCompareRoofViewerRoute: DebugCompareRoofViewerRoute,
  DebugCrashTestRoute: DebugCrashTestRoute,
  DebugDesignMaterialRoute: DebugDesignMaterialRoute,
  DebugDesignMaterialDocsRoute: DebugDesignMaterialDocsRoute,
  DebugDesignMaterialEditorRoute: DebugDesignMaterialEditorRoute,
  DebugError403Route: DebugError403Route,
  DebugExportRoute: DebugExportRoute,
  DebugExrTestRoute: DebugExrTestRoute,
  DebugExteriorSceneRoute: DebugExteriorSceneRoute,
  DebugFaceDiffViewerRoute: DebugFaceDiffViewerRoute,
  DebugHatchMaterialGenerationRoute: DebugHatchMaterialGenerationRoute,
  DebugHatchingTestRoute: DebugHatchingTestRoute,
  DebugIframeTestRoute: DebugIframeTestRoute,
  DebugImageServiceRoute: DebugImageServiceRoute,
  DebugMaterialAppearanceTestRoute: DebugMaterialAppearanceTestRoute,
  DebugMaterialCacheManagerRoute: DebugMaterialCacheManagerRoute,
  DebugMaterialIdRoute: DebugMaterialIdRoute,
  DebugMaterialThumbnailsRoute: DebugMaterialThumbnailsRoute,
  DebugOptionCatalogRepairRoute: DebugOptionCatalogRepairRoute,
  DebugPaletteThumbnailCacheBustRoute: DebugPaletteThumbnailCacheBustRoute,
  DebugPaletteThumbnailTestRoute: DebugPaletteThumbnailTestRoute,
  DebugPanoramaViewerRoute: DebugPanoramaViewerRoute,
  DebugPdfDiffRoute: DebugPdfDiffRoute,
  DebugPlanRenderRoute: DebugPlanRenderRoute,
  DebugPlanarGraphRoute: DebugPlanarGraphRoute,
  DebugPropAwsAdminRoute: DebugPropAwsAdminRoute,
  DebugPropAwsBatchRoute: DebugPropAwsBatchRoute,
  DebugPropsRoute: DebugPropsRoute,
  DebugRenderRoute: DebugRenderRoute,
  DebugRepairHomeRoute: DebugRepairHomeRoute,
  DebugSelectionsRoute: DebugSelectionsRoute,
  DebugServerErrorsRoute: DebugServerErrorsRoute,
  DebugShowroomFloorplanRoute: DebugShowroomFloorplanRoute,
  DebugShowroomGltfImportPerformanceRoute:
    DebugShowroomGltfImportPerformanceRoute,
  DebugShowroomIntroPerformanceRoute: DebugShowroomIntroPerformanceRoute,
  DebugSourceGraphAnalyzerRoute: DebugSourceGraphAnalyzerRoute,
  DebugSsrrTestRoute: DebugSsrrTestRoute,
  DebugStrokeTestRoute: DebugStrokeTestRoute,
  DebugSvgBbRoute: DebugSvgBbRoute,
  DebugTextTestRoute: DebugTextTestRoute,
  DebugTonemappingTestRoute: DebugTonemappingTestRoute,
  DebugViewerStateManagementRoute: DebugViewerStateManagementRoute,
  DebugWalkthroughRoute: DebugWalkthroughRoute,
  DebugWalkthroughCachingRoute: DebugWalkthroughCachingRoute,
  DebugWasmRoute: DebugWasmRoute,
  DebugWebglContextSharingRoute: DebugWebglContextSharingRoute,
  DebugWebglContextSharingTransformRoute:
    DebugWebglContextSharingTransformRoute,
  DebugWebglServiceRoute: DebugWebglServiceRoute,
  DemoIbs2023SelectionsRoute: DemoIbs2023SelectionsRoute,
  DemoIbs2023StartRoute: DemoIbs2023StartRoute,
  DemoIbs2023WalkthroughRoute: DemoIbs2023WalkthroughRoute,
  DemoPhotorealInterior360TS21DMPO80M1Route:
    DemoPhotorealInterior360TS21DMPO80M1Route,
  DemoPhotorealSelectionsRoute: DemoPhotorealSelectionsRoute,
  DemoPhotorealSelections360WX34VCTU45P2Route:
    DemoPhotorealSelections360WX34VCTU45P2Route,
  DemoPhotorealWalkthroughRoute: DemoPhotorealWalkthroughRoute,
  DemoSheetsRoute: DemoSheetsRoute,
  DemoShowroomRoute: DemoShowroomRoute,
  InvitesInvite_idRoute: InvitesInvite_idRoute,
  ShowroomIntroRoute: ShowroomIntroRoute,
  ShowroomStudioRoute: ShowroomStudioRoute,
  AdminIndexRoute: AdminIndexRoute,
  DebugIndexRoute: DebugIndexRoute,
  ShowroomIndexRoute: ShowroomIndexRoute,
  BuildersBuilder_idEstimateRouteRoute:
    BuildersBuilder_idEstimateRouteRouteWithChildren,
  BuildersBuilder_idOptionsRouteRoute:
    BuildersBuilder_idOptionsRouteRouteWithChildren,
  BuildersBuilder_idConfigureRoute: BuildersBuilder_idConfigureRoute,
  BuildersBuilder_idFilesRoute: BuildersBuilder_idFilesRoute,
  BuildersBuilder_idGuidedFlowRoute: BuildersBuilder_idGuidedFlowRoute,
  BuildersBuilder_idPlansRoute: BuildersBuilder_idPlansRoute,
  DebugBuilderWebsiteSalesMapRoute: DebugBuilderWebsiteSalesMapRoute,
  DebugBuilderWebsiteShowroomIntroRoute: DebugBuilderWebsiteShowroomIntroRoute,
  DebugFramingTruss2DRoute: DebugFramingTruss2DRoute,
  DebugGeomStraightSkeletonOffsetRoute: DebugGeomStraightSkeletonOffsetRoute,
  DebugGeomStraightSkeletonOffsetSingleRoute:
    DebugGeomStraightSkeletonOffsetSingleRoute,
  DebugGfxStressGeometryStressIncrementalRoute:
    DebugGfxStressGeometryStressIncrementalRoute,
  DebugGfxStressMaterialStressRoute: DebugGfxStressMaterialStressRoute,
  DebugGfxStressMaterialStressIncrementalRoute:
    DebugGfxStressMaterialStressIncrementalRoute,
  DebugGfxTestMaterialRenderRoute: DebugGfxTestMaterialRenderRoute,
  DebugGfxTestThreeviewerInitRoute: DebugGfxTestThreeviewerInitRoute,
  DebugOptionMigrationMigrateOptionsRoute:
    DebugOptionMigrationMigrateOptionsRoute,
  DebugPolyclipBrepSetOpsTestRoute: DebugPolyclipBrepSetOpsTestRoute,
  DebugPolyclipBrepTrimTestRoute: DebugPolyclipBrepTrimTestRoute,
  DebugPolyclipOffsetClosedTestRoute: DebugPolyclipOffsetClosedTestRoute,
  DebugPolyclipPlaneTrimTestRoute: DebugPolyclipPlaneTrimTestRoute,
  DebugPolyclipSetOpsBenchRoute: DebugPolyclipSetOpsBenchRoute,
  DebugPolyclipSetOpsFuzzRoute: DebugPolyclipSetOpsFuzzRoute,
  DebugPolyclipSetOpsTestRoute: DebugPolyclipSetOpsTestRoute,
  DebugPolyclipSnapRoundTestRoute: DebugPolyclipSnapRoundTestRoute,
  DebugPolyclipTrimFacesTestRoute: DebugPolyclipTrimFacesTestRoute,
  DebugSchemaBapiKamsRoute: DebugSchemaBapiKamsRoute,
  DebugSchemaBuildingApiRoute: DebugSchemaBuildingApiRoute,
  DemoConnectedBigscreenRoute: DemoConnectedBigscreenRoute,
  DemoConnectedShowroomRoute: DemoConnectedShowroomRoute,
  DemoConnectedSinglescreenRoute: DemoConnectedSinglescreenRoute,
  DemoConnectedTabsRoute: DemoConnectedTabsRoute,
  ShowroomEditIntroRoute: ShowroomEditIntroRoute,
  AdminComponentLibraryIndexRoute: AdminComponentLibraryIndexRoute,
  AdminDataMigrationIndexRoute: AdminDataMigrationIndexRoute,
  BuildersBuilder_idIndexRoute: BuildersBuilder_idIndexRoute,
  DebugBuilderWebsiteIndexRoute: DebugBuilderWebsiteIndexRoute,
  DebugFloorFramingIndexRoute: DebugFloorFramingIndexRoute,
  DebugGeomIndexRoute: DebugGeomIndexRoute,
  DebugOptionMigrationIndexRoute: DebugOptionMigrationIndexRoute,
  DebugWallFramingIndexRoute: DebugWallFramingIndexRoute,
  DemoConnectedIndexRoute: DemoConnectedIndexRoute,
  BuildersBuilder_idLocationsNewRoute: BuildersBuilder_idLocationsNewRoute,
  BuildersBuilder_idProcureSplatRoute: BuildersBuilder_idProcureSplatRoute,
  DebugGeomMiterSkeletonSkeletonRoute: DebugGeomMiterSkeletonSkeletonRoute,
  ShowroomPlanHome_plan_idOpsRoute: ShowroomPlanHome_plan_idOpsRoute,
  ShowroomPlanHome_plan_idOverviewRoute: ShowroomPlanHome_plan_idOverviewRoute,
  BuildersBuilder_idAccountIndexRoute: BuildersBuilder_idAccountIndexRoute,
  BuildersBuilder_idAutoRendersIndexRoute:
    BuildersBuilder_idAutoRendersIndexRoute,
  BuildersBuilder_idCommunitiesIndexRoute:
    BuildersBuilder_idCommunitiesIndexRoute,
  BuildersBuilder_idDevelopersIndexRoute:
    BuildersBuilder_idDevelopersIndexRoute,
  BuildersBuilder_idIntegrationsIndexRoute:
    BuildersBuilder_idIntegrationsIndexRoute,
  BuildersBuilder_idLocationsIndexRoute: BuildersBuilder_idLocationsIndexRoute,
  BuildersBuilder_idMarketingIndexRoute: BuildersBuilder_idMarketingIndexRoute,
  BuildersBuilder_idMasterPlansIndexRoute:
    BuildersBuilder_idMasterPlansIndexRoute,
  BuildersBuilder_idTasksIndexRoute: BuildersBuilder_idTasksIndexRoute,
  BuildersBuilder_idUsersIndexRoute: BuildersBuilder_idUsersIndexRoute,
  DebugGeomMiterSkeletonIndexRoute: DebugGeomMiterSkeletonIndexRoute,
  ShowroomPlanHome_plan_idIndexRoute: ShowroomPlanHome_plan_idIndexRoute,
  BuildersBuilder_idCommunitiesCommunity_idSplatRoute:
    BuildersBuilder_idCommunitiesCommunity_idSplatRoute,
  BuildersBuilder_idCommunitiesCommunity_idPlansRoute:
    BuildersBuilder_idCommunitiesCommunity_idPlansRoute,
  BuildersBuilder_idHomePlansHome_plan_idOverviewRoute:
    BuildersBuilder_idHomePlansHome_plan_idOverviewRoute,
  BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute:
    BuildersBuilder_idHomePlansHome_plan_idOverviewInternalRoute,
  BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute:
    BuildersBuilder_idHomePlansHome_plan_idSalesViewRoute,
  BuildersBuilder_idLocationsLocation_idEditRoute:
    BuildersBuilder_idLocationsLocation_idEditRoute,
  BuildersBuilder_idLocationsLocation_idHomePlansRoute:
    BuildersBuilder_idLocationsLocation_idHomePlansRoute,
  BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute:
    BuildersBuilder_idMasterPlansMaster_plan_idSalesViewRoute,
  BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute:
    BuildersBuilder_idMasterPlansMaster_plan_idShowroomRoute,
  BuildersBuilder_idAutoRendersItem_idIndexRoute:
    BuildersBuilder_idAutoRendersItem_idIndexRoute,
  BuildersBuilder_idHomePlansHome_plan_idIndexRoute:
    BuildersBuilder_idHomePlansHome_plan_idIndexRoute,
  BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute:
    BuildersBuilder_idMasterPlansMaster_plan_idIndexRoute,
  BuildersBuilder_idTasksTask_idIndexRoute:
    BuildersBuilder_idTasksTask_idIndexRoute,
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute:
    BuildersBuilder_idMarketingMasterPlansMaster_plan_idShowroomRoute,
  BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute:
    BuildersBuilder_idHomePlansHome_plan_idOpsViewIndexRoute,
  BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute:
    BuildersBuilder_idHomePlansHome_plan_idShowroomIndexRoute,
  BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute:
    BuildersBuilder_idLocationsLocation_idLocationPlansIndexRoute,
  BuildersBuilder_idLocationsLocation_idLotsIndexRoute:
    BuildersBuilder_idLocationsLocation_idLotsIndexRoute,
  BuildersBuilder_idLocationsLocation_idMapIndexRoute:
    BuildersBuilder_idLocationsLocation_idMapIndexRoute,
  BuildersBuilder_idLocationsLocation_idOptionsIndexRoute:
    BuildersBuilder_idLocationsLocation_idOptionsIndexRoute,
  BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute:
    BuildersBuilder_idLocationsLocation_idSalesMapIndexRoute,
  BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute:
    BuildersBuilder_idLocationsLocation_idStudioDocsIndexRoute,
  BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute:
    BuildersBuilder_idLocationsLocation_idSubLocationsIndexRoute,
  BuildersBuilder_idLocationsLocation_idTasksIndexRoute:
    BuildersBuilder_idLocationsLocation_idTasksIndexRoute,
  BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute:
    BuildersBuilder_idLocationsLocation_idWorkbooksIndexRoute,
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute:
    BuildersBuilder_idMarketingMasterPlansMaster_plan_idIndexRoute,
  DemoBuildersBuilder_nameSelectionsScene_idIndexRoute:
    DemoBuildersBuilder_nameSelectionsScene_idIndexRoute,
  DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute:
    DemoBuildersBuilder_nameWalkthroughsWalkthrough_idIndexRoute,
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute:
    BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idShowroomRoute,
  BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute:
    BuildersBuilder_idMasterPlansMaster_plan_idCommunity_idPlan_idSalesViewRoute,
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute:
    BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idIndexRoute,
  BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute:
    BuildersBuilder_idLocationsLocation_idLotsLot_idIndexRoute,
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute:
    BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idShowroomRoute,
  BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute:
    BuildersBuilder_idMarketingMasterPlansMaster_plan_idCommunity_idPlan_idIndexRoute,
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute:
    BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idShowroomRoute,
  BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute:
    BuildersBuilder_idMasterPlansMaster_plan_idCommunitiesCommunity_idCommunityPlansCommunity_plan_idSplatRoute,
  BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute:
    BuildersBuilder_idLocationsLocation_idLocationPlansLocation_plan_idLotsLot_idIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
